import { m } from "framer-motion";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";

export const translations = {
    en: {
        help: 'Need help? Contact <a href="mailto:support@abstracht.com">support@abstracht.com</a>',
        no_data_found: "No data found...",
        yes: "Yes",
        save: "Save",
        close: "Close",
        delete: "Delete",
        create: "Create",
        search_filter: "Filter data by searching...",
        reload: "Reload",
        no_data_found_by_search: "No data found matching your search...",
        no_data: "No data available...",
        name: "Name",
        full_name: "Full name",
        title: "Title",
        description: "Description",
        message: "Message",
        mandatory_field: "Mandatory field",

        type_confirm: "To confirm, type",
        documentation: "Documentation",

        select: "Select",
        selected: "selected",
        create_new: "Create new",
        here: "here",

        created_at: "Created at",
        updated_at: "Updated at",
        no_logs: "No logs available",
        log: "Log",
        error_occurred: "An error occurred",
        connect: "Connect",
        disconnect: "Disconnect",
        no_abilities: "No abilities found...",
        loading: "Loading...",
        different_version: "The deployed version and your connected version differ. We recommend reconnecting to sync them.",
        reasoning: "reasoning",

        insufficient_funds: "Your wallet balance is too low. Please add funds or enable auto top-up.",
        open_directory: "Open directory",
        stop: "Stop",
        send: "Send",
        cancel: "Cancel",
        next: "Next",
        back: "Back",

        public: "Public",
        custom: "Custom",

        pages: "Pages",
        page: "Page",

        documents: "Documents",
        document: "Document",

        copy: "Copy",
        copied: "Copied",

        website: {
            navbar: {
                dashboard: "Dashboard",
                waitlist: "Join waitlist",
                start_now: "Start now",
                login: "Login"
            },
            sidebar: {
                abilities: "Abilities",
                fine_tuning: "Fine tuning and agents",
                team_managment: "Team managment",
                pricing: "Pricing"
            },
            footer: {
                all_rights: "All rights reserved.",
                legal: "Legal Notes",
                privacy: "Privacy policy",
                terms: "Terms and Conditions",
                t0r: 'Abstracht is a <a href="https://t0.abstracht.com">Type Zero</a> company'
            },

            main_title: "Build your AI",
            main_subtitle: "Give expert models unlimited capability, then stand back.",
            build_software: "Build software",
            create_agents: "Create agents",
            fine_tune: "Fine-tune LLMs",
            centralized_search: "Centralized search",
            team_orch: "Team orchestration",
            input_placeholder: "Describe what you want to build...",

            phrases: [
                "Generate a consolidated Q4 financial report including treasury position, cash flow projections, and variance analysis across all subsidiaries.",
                "Analyze customer churn over the last 12 months and identify the primary behavioral and revenue drivers impacting retention.",
                "Create a standardized onboarding workflow for new enterprise clients, including compliance checks and internal approval flows.",
                "Automate invoice reconciliation by matching ERP records with bank transactions and flagging inconsistencies for review.",
                "Deploy an AI support agent trained on internal documentation to handle Tier 1 customer service inquiries.",
                "Draft a GDPR-compliant data governance policy covering data access, storage, retention, and third-party integrations.",
                "Forecast revenue for the next fiscal year using historical performance, seasonality trends, and current pipeline data.",
                "Optimize supply chain logistics by identifying bottlenecks in procurement, warehousing, and last-mile delivery.",
                "Generate a board-ready executive summary outlining operational KPIs, risk exposure, and strategic initiatives.",
                "Monitor regulatory changes across EU markets and automatically update internal compliance documentation."
            ],
            pricing: {
                title: "Pricing",
                subtitle: "See pricing for personal, businesses and enterprise plans",
                monthly: "Monthly",
                yearly: "Yearly",
                custom: "Custom",
                more_info: 'More info about pricing can be found <a href="https://www.abstracht.com/pricing"  target="_blank" rel="noopener noreferrer">here</a>'
            },
            how_payments_work: {
                one_title: "How payments work",
                one_subtitle: " Payments depend on the services you use. Your account operates on a prepaid wallet system.  You can add funds using a credit card (SEPA support coming soon). Your balance is automatically used as you consume services.",
                two_title: "AI Usage",
                two_subtitle: "AI (LLM) usage is billed in real time based on the number of input and output tokens processed. Pricing varies by model.",
                three_title: "Abilities",
                three_subtitle: "Abilities are billed per execution. Pricing is calculated based on execution time, compute usage, and number of requests.",
                four_title: "Actions",
                four_subtitle: "   One-time actions are billed at $0.01 per execution. Scheduled actions are billed at $0.01 per day while active.",
                five_title: "What happens if your wallet has no credit?",
                five_subtitle: "  If your wallet balance reaches zero, all services (AI, Abilities, and Actions) will stop immediately. To resume usage, you must top up your wallet.",
            },
            use_cases: {
                use_case_data: [
                    {
                        kicker: "Data",
                        title: "Unified data access",
                        desc: "Easily import data from multiple sources, create custom connectors, or deploy pre-built databases with a single click. The data is processed and structured so both you and the model can read and retrieve it efficiently.",
                    },
                    {
                        kicker: "Intelligence",
                        title: "Smart LLM management",
                        desc: "Select from a variety of LLMs and choose whether to fine-tune them for specific use cases. Each LLM comes with an integrated Cognitive Memory, allowing it to retrieve relevant information when needed instead of relying solely on context.",
                    },
                    {
                        kicker: "Scale",
                        title: "Seamless team scaling",
                        desc: "Create teams and users, and scale your personalized LLM across autoscalable clusters effortlessly, ensuring performance and accessibility for all members.",
                    },
                ]
            },
            ai_enterprise: {
                kicker: "AI FOR ENTERPRISE",
                title: "Deploy AI at Scale",
                subtitle: "Build, integrate, and scale AI solutions across your organization.",

            },
            sales: {
                contact_btn: "Contact sales",
                subtitle: "We'll get back to you as soon as possible",
                message_placeholder: "Leave a brief message...",
                email_err_mex: "Email is required",
                name_err_mex: "Full name is required",
                req_success: "We've received your request!",
                thanks: "Thanks for reaching out, we'll get back to you within 1–2 business days.",
                back_home_btn: "Back to homepage",
            }

        },
        register_form: {
            create_account: "Create an account",
            newsletter: "I would like to receive news and updates.",
            privacy_continue: 'By continuing i accept the <a href="/privacy">Privacy policy </a> | <a href="/terms-and-conditions">Terms and conditions</Link>',
            with_google: "with Google",
            name: "Name",
            surname: "Surname",
            phone: "Phone",
            repeat_password: "Repeat password",
            button_register: "Sign Up",
            already_registered: "Already registered?",
            go_login: "Login",
            email_format: "The email format is incorrect...",
            password_err: "Password must be at least 10 characters long and contain uppercase letters, lowercase letters, special characters, and numbers..",
            password_match: "Passowrds don't match...",
            red_fields: "Check the required fields...",
            email_already_present: "Email already present...",
            errors_back: "An error was detected...retry",
            problem_back: "There is a problem with the access...rety in a few minutes",
            terms_conditions_desc: "I have read and accept the",
            t_c: "Terms and conditions",
            privacy_policy_desc: "I have read and accept the",
            p_p: "Privacy Policy",
            button_login: "Login",
            dont_have_account: "Don't have an account?",
            go_register: "Register",
            invalid_email_pass: "invalid email or password...retry",
            welcome_to: "Welcome to",
            description_one: "Built for massive data operations and intelligent cloud orchestration, Abstracht brings performance and simplicity together with lightning-fast storage, compute power, and vector intelligence managed by a purpose-built AI.",
            welcome_back: "Welcome back!",
            update_mex: "The Abstracht Python SDK has arrived — install it today and integrate effortlessly.",
        },
        verification: {
            title: "Verifying your email...",
            verified_title: "Email verified",
            verified_subtitle: "Your account has been successfully verified. You'll be redirected to shortly.",
            failed_verified_title: "Verification failed...",
            failed_verified_subtitle: "The verification link is invalid or has expired.",
            verify_email_title: "Verify your email!",
            verify_email_subtitle: "We've sent a verification link to ",
            verify_email_message: "Please check your inbox (and spam folder) and click the link to activate your account.",
            resend_btn: "Resend email",
            email_sent: "Email sent successfully!",
            email_sent_sub: "Please check your inbox."
        },
        onboarding: {
            five_options: "You have to select three options...",
            one_option: "You have to select one option...",
            welcome: "Welcome",
            welcome_sub: "Let's get your account set up. This will only take a moment.",
            ready: "I'm ready",
            continue: "Continue",
            back: "Back",
            language: {
                title: "Choose a language",
                subtitle: "You can always change it later",
                warning: "Most LLMs are primarily trained on English-language data, so even if you preselect another language, the model may still respond in English at times."
            },
            personal_info: {
                phone_prefix_required: "Phone prefix is required...",
                phone_required: "Phone is required...",
                invalid_phone: "Invalid phone number format",
                street_required: "Street is required...",
                street_n_required: "Street number is required...",
                city_required: "City is required...",
                country_required: "Country is required...",

                title: "Profile",
                subtitle: "Let's complete your profile setup",
                phone: "Phone",
                street_n: "Street & number",
                city: "City",
                country: "Country",
                no_countries: "No countries found...",
                billing_matches: " Billing information matches provided data",
                billing_title: "Billing info",
                billing_subtitle: "Add the billing details",
            },
            experience: {
                title: "Choose your experience",
                subtitle: "You can always change it later",
                light: "Light",
                dark: "Dark",
                system: "System"
            },
            about_you: {
                title: "Let's talk about you...",
                subtitle: "What describes you best",
                about_you_options: [
                    { value: "developer", label: "Developer / Engineer" },
                    { value: "designer", label: "Designer" },
                    { value: "product_manager", label: "Product Manager" },
                    { value: "it_devops", label: "IT / DevOps" },

                    { value: "marketing", label: "Marketing Professional" },
                    { value: "sales", label: "Sales Professional" },
                    { value: "operations", label: "Operations" },
                    { value: "finance", label: "Finance" },
                    { value: "hr", label: "HR / People Ops" },
                    { value: "customer_support", label: "Customer Support" },

                    { value: "founder", label: "Founder / Co-Founder" },
                    { value: "executive", label: "Executive (CEO, CTO, etc.)" },
                    { value: "manager", label: "Manager" },

                    { value: "creator", label: "Content Creator" },
                    { value: "writer", label: "Writer" },
                    { value: "artist", label: "Artist" },

                    { value: "tradesperson", label: "Skilled Tradesperson" },
                    { value: "mechanic", label: "Mechanic" },
                    { value: "barber", label: "Barber / Hairdresser" },

                    { value: "hospitality_worker", label: "Hospitality Worker" },
                    { value: "retail_worker", label: "Retail Worker" },
                    { value: "driver", label: "Driver / Delivery" },

                    { value: "student", label: "Student" },
                    { value: "teacher", label: "Teacher / Educator" },

                    { value: "freelancer", label: "Freelancer / Self-employed" },
                    { value: "employee", label: "Employee" },

                    { value: "other", label: "Other" }
                ]
            },
            team: {
                title: "About your team...",
                subtitle: "How many people will work with you",
                about_you_options: [
                    { value: "only_1", label: "Only me" },
                    { value: "1_5", label: "1 to 5 people" },
                    { value: "5_10", label: "5 to 10 people" },
                    { value: "10_25", label: "10 to 25 people" },
                    { value: "25_100", label: "25 to 100 people" },
                    { value: "100_200", label: "100 to 200 people" },
                    { value: "200_more", label: "more than 200" },
                ]
            },
            payment: {
                title: "Complete checkout",
                subtitle: "Complete the checkout for your subscription. <br />You can always change it later in the billing section.",
                checkout_for: "Checkout for",
                summary: "Payment summary",
                ammount: "Ammount",
                next_payment: "Next payment",
                date_info: "The date for the next payment is in the following format: DD/MM/YYYY",
                interval: "Interval",
                recurring: "Recurring",
            },
            done: {
                title: "You are ready!",
                subtitle: "You're all set up and ready to start!",
                open_dashboard: "Open dashboard"
            }
        },
        payments: {
            label: "Payment method label",
            label_required: "Payment method label is required",
            card_details: "Card details",
            card_details_required: "Card details are required",
            sensitive_mex: 'No sensitive payment information is stored on our servers. All payments are securely processed by <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">Stripe</a>, which uses industry-standard encryption and complies with strict security standards to protect your data.',
            pay_continue: "Pay and continue"
        },
        logout_modal: {
            title: "Are you sure you want to logout?",
            subtitle: "Log out of Abstracht as "
        },
        sidebar: {
            create: "Create",
            manage: "Manage",
            monitor: "Monitor",
            organizations: "Organizations",
            members: "Members",
            api_keys: "API Keys",
            storage: "Storage",
            billing: "Billing",
            analytics: "Analytics",
            logs: "Logs",
            chat: "Chat",
            build: "Build",
            playground: "Playground",
            chat_history: "Chat history",
            abilities: "Abilities",
            actions: "Actions",
            apps: "Apps",
            organization: "Organization",
            admin_panel: "Admin panel",
            alert_payment: {
                title: "Set up payment",
                subtitle: "Add a payment method to get started",
                btn: "Add payment method",
            },
            alert_abilities: {
                title: "Need more abilities?",
                subtitle: "Get pre-build abilities from our public directory.",
                btn: "Open directory",
            },

            language: "Language",
            workspace: "Workspace",
            theme: "Theme",
            profile: "Profile",
            logout: "Logout"

        },
        profile: {
            title: "Edit profile",
            name: "Name",
            surname: "Surname",
            email: "Email",
            account_id: "Account ID",
            info: "Your email helps others quickly recognize and identify you when collaborating."
        },
        delete_modal: {
            delete: "Delete",
            error_val_match: "The entered value does not match. Please type the exact name to confirm.",
        },
        organizations: {
            title: "Organizations",
            subtitle: "View and manage all registered organizations within the system.",
            empty_subtitle: "Create a new organization and start scaling AI across your teams",
            quest_title: "What is an organization?",
            quest_answ: "An organization is a collaborative hub for your workspace. Whether it represents a specific team, a department, or a project group, it allows you to centralize AI resources, manage members, and scale your workflows together in one place.",

            org_name_required: "Organization title is required",
            org_desc_required: "Organization description is required",
            new_organization: "New organization",

            manage_organization: "Manage organization",
            settings: "Settings",
            members: "Members",
            close_org: "Close organization",

            warning_points: [
                "This Organizations will become permanently unavailable to all members.",
                "All members will be removed from the organization.",
                "This organization will become permanently unavailable to all users.",
                "All abilities tied to this organization will be permanently removed.",
                "All actions tied to this organization will be permanently stopped and removed.",
                "All associated data (chats, code, URLs, connections etc.) will be deleted permanently.",
            ],
            all_warnings_mex: "All the warnings must be checked",
            warning_del: 'Deleting this organizations is <strong>permanent</strong> and <strong>irreversible</strong>. Once deleted, it will be <strong>completely removed from the system</strong>, including all versions, associated data (chats, code, URLs, etc.), and any user connections.<br /><br /><strong>THIS ACTION CANNOT BE UNDONE</strong>',
            confirm_title: "Confirmation required",
            confirm_subtitle: "Please confirm that you have read and accept the terms.",
            i_confirm: "I confirm and want to proceed"
        },
        members: {
            title: "Members",
            subtitle: "View and manage all registered members and their access levels.",
            empty_subtitle: "Create new members and assign them to an organization.",
            quest_title: "Who is a member?",
            quest_answ: "A member is an individual user. You can assign them to organizations, define roles, and control access levels to manage permissions.",
            role_options: {
                owner: "Owners have total oversight of the organization, from managing the team to adjusting configurations. Please assign this role only to those who require full access.",
                manager: "Managers focus on team operations and member management, but have restricted access to technical model configurations and fine-tuning.",
                developer: "Developers have full technical access to build, fine-tune, and assign models, but do not have permission to manage team members or organization settings.",
                member: "Members have standard access to use existing tools and create personal workflows, with no administrative or model configuration permissions."
            },
            user: "User",
            org_roles: "Organizations and roles",
            invite_member: "Invite a team member",
            role: "Role",
            more_info: "For more info click",
            invite: "Invite",
            all_org_role: "All organizations must have a role",
            update_title: "Update team member",
            org_roles: "Organizations & Roles",
            warning_permissions: `<strong>Action Restricted</strong><br />You don't have the permissions to perform member updates`,
            warning_creator: "<strong>Action Restricted</strong><br /> This member is the creator of the organization and cannot be changed or removed. The creator has full administrative privileges, and removing them could break access control or ownership of the organization. To make changes, you can transfer ownership or contact the system administrator.",
            warning_remove: '<strong>You are about to remove this member from the organization.</strong>.<ul><li>The member will lose access to all tools, workflows, and data associated with this organization.</li><li>This action cannot be undone from this modal.</li><li>To restore access, the member must be re-added to the organization</li></ul>'

        },
        api_keys: {
            title: "API Keys",
            subtitle: "View and manage all API keys. Monitor usage, control access, and securely integrate AI services across your systems.",
            empty_subtitle: "Create an API Key and start integrating AI into your applications.",
            quest_title: "What are API Keys?",
            quest_answ: "API keys are secure credentials used to authenticate your applications when accessing AI services. By organizing your workspace, you can create, manage, and monitor API keys across different teams, projects, or environments.",

            new_item: "New API Key",
            api_key: "API Key",
            api_warning: "This key is shown once, save it securely and keep it private.",
            exp_date: "Expiration date",

            name_required: "API Key name is required",
            desc_required: "API Key description is required",

            exp_date_mex: "Please select an expiration date",

            expired_date_msg: "Expiration date cannot be in the past",

            delete_title: "Delete API Key",
            delete_desc: "Deleting this API key will permanently revoke access. Any applications or services using it will stop working immediately. This action cannot be undone."
        },
        storage: {
            title: "Storage",
            subtitle: "View and manage all files and folders.",
            new_folder: "New folder",
            upload_files: "Upload files",
            delete_folder: "Once this folder is deleted, it will permanently delete the folder and all its contents.",
            delete_file: "Once this file is deleted, it will be permanently removed.",
            folder_name_required: "Folder name is required",
            org_required: "Organization is required",
            folder_alredy_present: "Folder already exists. Use another name.",
            folder_name: "Folder name",
            share_with_org: "Share with an organization",
            share_warning: "Assigning this folder to an organization will make it accessible to all its members.",
            max_files_upload: "You can upload a maximum of 10 files",
            min_files_upload: "At least 1 file is required",
            share_files_warning: "Assigning files to an organization will make them accessible to all its members.",
            click_drag: "Click or drag files here"
        },
        billing: {
            title: "Billing",
            wallet: "Wallet",
            usage: "Usage",
            payment_info: "Payment info",
            usage_activity: "Usage activity",
            download_csv: "Download CSV",
            add_card: "Add card",
            open_wallet: "Open card wallet",
            credit_balance: "Credit balance",
            top_up: "Top up",
            payment_activity: "Payment activity",
            min_5_credit: "A minimum of $5.00 is required for credit amount",
            min_5_threshold: "A minimum of $5.00 is required for threshold amount",
            min_10_threshold: "A minimum of $10.00 is required for threshold amount",
            pyment_method_name_required: "Payment method name is required ",
            add_credits: "Add credits",
            credits: "Credits",
            pay_method_name: "Payment method name",
            card_details: "Card details",
            automatic_topup: "Automatic top up?",
            when_below: "When credit balance goes below",
            bring_up: "Bring credit balance back up to",
            add_payment_method: "Add payment method",
            default: "Default",
            set_default: "Set as default",
            your_card_wallet: "Your card wallet",
            add_new_card: "Add new card",
            default_card: "Default card",
            delete_payment_method: "Delete payment method?",
            delete_card_warning: "You are about to delete this payment method. This action cannot be undone, and this card will be permanently removed from your account."
        },
        analytics: {
            title: "Analytics",
            api_requests: "API Reqeusts",
            abilities: "Abilities",
            actions: "Actions",
            total_requests: "Total requests",
            activity_logs: "Activity logs",
        },
        logs: {
            title: "Logs",
            subtitle: "View all logs and monitor event statuses here.",
            empty_subtitle: "There are no logs yet. Start tracking events here.",
            quest_title: "What is a log?",
            quest_answ: "Logs record important events, like creating an API Key, an organization or uploading a file. This way you can monitor progress and statuses.",
        },
        chat_history: {
            title: "Chat history",
            empty_subtitle: " All your conversations will appear here once you start a chat.",
            quest_title: "What are chats?",
            quest_answ: " Chats are your recorded conversations with the system, they help you track past interactions, review messages, and manage your workflow efficiently.",
            used_models: "Used models",
            delete_title: "Delete chat?",
            delete_warning: "This chat will be deleted permanently. This action cannot be undone."
        },
        actions: {
            title: "Actions",
            subtitle: "View, manage, and monitor all your actions in one place.",
            empty_subtitle: "Automate your tasks by creating actions that can run instantly or on a schedule.",
            quest_title: "What is an action?",
            quest_answ: " Use AI-powered actions to automate repetitive tasks and streamline your processes. Trigger them on demand or schedule them to run automatically in the background.",

            delete_title: "Delete action?",
            delete_warning: "This action will be deleted permanently. This operation cannot be undone.",

            action_title_req: "Action title is required",
            action_desc_req: "Description is required",
            desc_too_long: "Action description is too long. Max 300 characters.",

            create_new_action: "Create new action",
            desc_placeholder: "Describe what this action does...",

            trigger_type: "Trigger type",
            last_run_status: "Last run status",
            last_run: "Last run",

            scheduled: "Scheduled",
            one_time_run: "One time run",

            interval_req: "Interval is required",
            repeat_req: "Repeat evty is required",

            save_run_action: "Save and run action",

            interval: "Interval",
            repeat_every: "Repeat every",


            minutes: "Minutes",
            hours: "Hours",
            days: "Days",
            weeks: "Weeks",
            months: "Months",

            private_action_warning: "This action is private and accessible only within your account. Use it for testing or internal purposes. You can publish it later into the organization.",
            public_action_warning: " This action will be published globally to all Abstracht users. Use this for community-wide sharing. Ensure no sensitive data is included.",
            save_run: "Save & run",
            steps: "Steps",
            step: "Step",
            append_actions: "Append action",
            ability: "Ability",
            action_logs: "Action logs"
        },
        playground: {
            error_gen: "An error occured while the AI was generating an anwswer. Please try again.",
            choose_llm_title: "Choose from available LLMs",
            sys_inst_title: "Add system instructions",
            new_intruction: "New instruction",
            instructions: "Instructions",
            reset: "Reset",

            delete_instruction_title: "Delete instruction?",
            delete_instruction_warning: "This instruction will be deleted permanently. This action CANNOT be undone.",

            web_search: "Web search",
            no_links: "No link selected",
            all_abilities: "All abilities",

            ai_settings: "AI Settings",
            sys_instructions: "System Instructions",
            sys_desc: "Define the model's persona, boundaries, and response style.",
            temperature: "Temperature",
            reasoning_depth: "Reasoning depth",
            open_abilities: "Open all abilities",
            memory: "Memory",
            memory_mex: "Memory lets the model remember past conversations. You can turn it on or off at any time.",
            json_mode: "JSON Mode",
            ls_mex: "Settings are stored in browsers local storage",


            build_title: "Build on Abstracht",
            more_mex: "Load more messages....",
            memory_on: "Memory ON",
            add_files_docs: "Add files & docs",


            suggestions: {
                title_one: "Deep Research",
                subtitle_one: "Synthesize complex topics into structured reports using live web access.",

                title_two: "Code Architecture",
                subtitle_two: "Debug scripts, refactor functions, or scaffold entire boilerplate projects.",

                title_three: "Creative Content",
                subtitle_three: "Draft compelling newsletters, technical blogs, or social media copy.",

                title_four: "Data Analysis",
                subtitle_four: "Upload CSVs to visualize trends and extract actionable insights instantly.",

            },
            open_resource: "Open resource",
            search_results: "Search results",
            input_placeholder: "Start typing a prompt, use enter to send"
        },
        abilities: {
            title: "Abilities",
            subtitle: "View, manage or import abilities in your system.",

            empty_subtitle: "Build custom abilities to extend what your AI can do.",
            quest_title: "What is an ability?",
            quest_answ: "An ability enables your AI to interact with external tools, services, or even physical devices like robots. By adding abilities, you unlock new functionality, allowing your AI to automate tasks, integrate with your workflows, and operate beyond its built-in features.",

            ability_name_req: "Ability title is required",
            ability_desc_req: "Ability description is required",
            ab_desc_long: "Ability Description is too long. Max 300 characters.",
            one_cat_req: "At least 1 category is required",
            transp_req: "Transport type is required",
            tool_req: "At least 1 tool is required",
            license_req: "License is required",
            region_req: "Region is required",
            endpoint_url_req: "Endpoint URL is required",

            ab_placeholder: "Describe what this ability enables the AI to do...",

            build_new_ability: "Build new ability",
            build_py: "Build your ability using Python and FastAPI.",
            build_js: "Build your ability using Node.js and Express.",

            runtime: "Runtime",
            source_url: "Source URL",
            category: "Category",
            region: "Region",
            endpoint_url: "Endpoint URL",
            select_option: "Select option",

            unsaved_title: "You have unsaved changes",
            continue_unsaved: "Continue without saving",

            warning_points: [
                "This Ability will become permanently unavailable to all users.",
                "All versions of this Ability will be deleted permanently.",
                "All users will permanently lose any connection to this Ability.",
                "You will only be billed for the time your Ability instance was actively running.",
                "All associated data (chats, code, URLs, connections etc.) will be deleted permanently.",
            ],

            delete_ability: "Delete ability",
            delete_success_title: "Ability deleted successfully",
            delete_success_subtitle: "Your ability has been removed. Redirecting you to the abilities directory...",
            delete_warning: "Deleting this Ability is <strong>permanent</strong> and <strong>irreversible</strong>. Once deleted, it will be <strong>completely removed from the system</strong>, including all versions, associated data (chats, code, URLs, etc.), and any user connections.<br /><br /><strong>THIS ACTION CANNOT BE UNDONE</strong>",
            all_warnings_checked: "All the warnings must be checked",

            abilities_builder: "Abilities builder",
            publishing: "Publishing",
            publish: "Publish",
            versioning: "Versioning",
            saving: "SAVING",
            saving_sm: "Saving",
            published: "PUBLISHED",
            few_minutes: "This might take a few minutes...",

            welcome_title: "Welcome to the ability builder",
            welcome_subtitle: "Create, customize, and deploy your own abilities with ease. Use AI to generate and test your ability automatically, or build everything manually with your own code for full control.",

            max_four_inst: "You can create max 4 instances.",
            publish_ability: "Publish ability",

            public_warning: " This ability will be published globally to all Abstracht users. Use this for community-wide sharing. Ensure no sensitive data is included.",
            private_warning: "This ability is private and accessible only within your account. Use it for testing or internal purposes. You can publish it later into the organization.",

            compute_settings: "Compute settings",
            memory: "Memory",
            scaling: "Scaling (Max Instances)",
            region: "Region",
            region_warning: "Once region is set during initial setup it cannot be updated",
            network_warning: "The network access is set to Public<br />This Ability is accessible to anyone with the URL and endpoint. Use caution when sharing or exposing this service.",
            publishing_warn: "If this isn't the version you expected, save your changes or select a different version before publishing.",
            settings: "Settings",

            fill_field: "Please fill in the required field",
            auth_req: "Authorization is required",
            failed_conn: "Failed to connect to ability. Retry.",
            creator: "Creator",
            sys_provider: "System provider",
            config_req: "Required configuration",
            authorization: "Authorization",
            i_auth: "I authorize Abstracht to execute this ability on my behalf.",

            disconnect_mex: "If you disconnect, you'll lose access to all features within this app and your saved data will be cleared.",

            ability_logs: "Ability logs",

            deployment_error: "Deployment error",
            deployment_err_subtitle: "An error occurred while publishing the ability. Please check the logs for details and try again.",

            ability_info: "Ability info",
            drafted_version: "Drafted version",
            published_version: "Published version",

            items_mcp: [
                {
                    desc: "Help me keep my customer contacts up to date by analyzing their recent email interactions and applying relevant changes automatically."
                },
                {
                    desc: "Notify my team in Slack whenever a new sales opportunity appears in my CRM so nothing important gets missed."
                },
                {
                    desc: "Organize my meeting notes and ensure they are automatically linked to the correct project context in Notion."
                },
                {
                    desc: "Plan and schedule my meetings by understanding priorities, availability, and suggested time slots from my AI assistant."
                },
                {
                    desc: "Monitor payment activity and alert me when key billing events happen, such as upgrades, cancellations, or failed charges."
                },
                {
                    desc: "Analyze incoming leads and provide a summary of their potential value along with recommended follow-up actions."
                },
                {
                    desc: "Sort and prioritize my emails by identifying important customer messages and grouping them by urgency and relevance."
                }
            ],

            new_chat: "New chat",
            ask_anything: "Ask me anything...",
            runt_test: "Run test",
            autotest_warn: "When autotest is enabled, the AI will publish and test the MCP automatically. Use with caution.",
            finalizing_conn: "Finalizing connection...",
            connection_success: "Connection successful!",
            connection_error: "Failed to connect...",
            conn_succ_subtitle: "Your connection was successful. <br />You'll be redirected shortly, please keep this window open.",
            conn_error: "We couldn't establish the connection. <br />Please go back and try again, or contact support if the issue persists.",
            test_warn: "We're currently testing the connection by automatically sending a message to your inbox. <br />Please keep this window open."
        },
        directory: {
            tag_required: "Tag is required",
            verified: "ability and its connection have been verified by Abstracht.",
            not_verified: "We are currently validating the connection gateway with the providers team. While the connection is active and secure, it is still undergoing verification by the provider. During the connection process in the consent screen, you may see a “not verified” or “unverified” status, you can ignore it and continue the connection.",
            once: "can be added once per organization.",
            multiple: "can be added multiple times per organization.",
            no_permission: "No permissions",
            warning_plublishing: "ability will be published inside the selected organizations and all the members will be able to connect to it.",
            addedd_success: "Ability added successfully",
            confirmation: "The ability has been successfully added to your account and is now ready to use. You can access it at any time from your “Abilities” section, where it will appear alongside your other active integrations.",
            continue_dir: "Continue in the directory",
            go_to: "Go to E8 Console",
            get_ability: "Get ability",
            welcome: "Welcome to the abilities directory",
            explore: "Explore a growing collection of public abilities, seamlessly import them into your environment, or share your own creations with the world.",
            punchline_desc: "Abilities transform language models from passive systems into active participants in the real world. They go beyond static integrations or predefined protocols, these are not just connectors or MCPs, but living extensions of intelligence, designed to grow and evolve over time."
        },
        omnit0: {
            kicker: "We're proud of...",
            description: "Omni-t0 is the intelligent orchestration system developed by Type Zero Research. <br/> <br/> It dynamically routes each request to the most suitable AI model based on the user’s intent, task complexity, speed requirements, and context. The system operates across a distributed pool of large language models and inference providers, combining leading third-party models with proprietary fine-tuned models developed internally by Type Zero Research. <br/> <br/>By continuously evaluating performance, specialization, latency, and cost-efficiency, Omni-t0 delivers optimized responses for a wide range of use cases, from reasoning and coding to creative generation and multilingual interaction.<br/><br/> Designed as a multi-model intelligence layer, Omni-t0 abstracts the complexity of model selection, allowing users to interact through a single unified interface while the system automatically chooses the best AI stack for every request."
        },
        finetune: {
            title: "Fine-Tuning",
            subtitle: "Create, manage, and monitor fine-tuned models and training jobs",
            empty_subtitle: "Select a base model and customize it to better fit your specific use case",
            quest_title: "What is fine-tuning?",
            quest_answ: "Fine-tuning is the process of training a pre-trained AI model on your own data so it can perform better on specific tasks, styles, or domains.",

            title_required: "Title is required",
            desc_required: "Description is required",

            new_title: "New fine-tuning job"
        },
        apps: {
            title: "Apps",
            subtitle: "Manage and create apps.",
            empty_subtitle: "Build and launch web apps seamlessly, all in one place.",
            quest_title: "How do apps work?",
            quest_answ: "Apps can be built and deployed for internal or public use, with integration support for abilities, workflows, and tools to maximize flexibility.",

            title_required: "Title is required",
            desc_required: "Description is required",

            new_title: "Build new app"
        },
        geo: {
            title: "GEO",
            subtitle: "Generative Engine Optimization",
            empty_subtitle: "Simulate how AI engines discover, understand, and recommend your brand.",
            quest_title: "What is GEO?",
            quest_answ: "Generative Engine Optimization (GEO) helps your brand become more visible and relevant in AI-generated answers. Analyze how AI engines understand your company, identify gaps in your visibility, and simulate strategies to improve how your brand is discovered, referenced, and recommended.",
            title_required: "Please enter a title",
            desc_required: "Please enter a description",
            new_title: "New GEO Optimization",
            update_title: "Update GEO Optimization",
            name_required: "GEO optimization title is required...",
            desc_required: "GEO optimization description is required...",
            title_placeholder: "Ex: Product launch",
            description_placeholder: "Ex: Optimization campaign for new product launch...",
            delete_title: "Delete GEO optimization",
            delete_desc: "This will permanently delete the optimization and all associated information, and discontinue any active monitoring or execution. Once deleted, this action cannot be undone.",
            geo_context_title: "Select your context",
            geo_context_description: "Choose the context that will guide your AI simulations and shape their results.",
            geo__prop_filter_placeholder: "Filter by ID, name, domain, base URL, or date...",
            geo_filter_placeholder: "Filter by ID, title, description, or date...",
            select_all: "Select all",
            deselect_all: "Deselect all",
            item: "Item",
            items: "Items",
            no_sources: "No sources",
            sources: "Sources",
            source: "Source",
            warning_no_sources: "Some selected contexts have no sources! <br/> To continue, add at least one source to each selected context. This ensures your AI simulations are based on relevant information and deliver more accurate results.",
            need_context: "Need a new context?",
            need_property: "Need a new property?",
            click_here: "Click here",
            define_goal_title: "Define your goal",
            define_goal_description: "What do you want to achieve with this GEO optimization? Describe your goal so the AI can identify relevant customer topics, generate realistic search simulations, and uncover opportunities to improve your visibility across AI engines.",
            goal_placeholder: "What do you want to achieve with this optimization?",
            goal_explain: "Your goal guides the AI in generating relevant customer topics, realistic search simulations, and actionable insights tailored to your objectives.",
            topic_info: "Topic info",
            new_topic: "New topic",
            intent_type_required: "Intent type is required...",
            intent_name_required: "Topic name is required...",
            intent_desc_required: "Topic description is required...",
            intent_type: "Intent type",
            topic: "Topic",
            select_intent_type: "Select intent type",
            topic_name_placeholder: "Enter a topic... ",
            topic_description_placeholder: "Describe the topic and the types of customer intent it should cover... ",
            informational: "Informational",
            commercial_investigation: "Commercial investigation",
            transactional: "Transactional",
            comparative: "Comparative",
            problem_solving: "Problem solving",
            context_id: "Context id",
            topics: "Topics",
            geo_topics_description: "The AI will use your selections to generate relevant, realistic simulations.",
            create_custom_topic: "Create custom topic",
            geo_topics_warning: "The topics guide the AI in generating realistic customer-like prompts and simulations, reflecting how real people search for information, ask questions, and explore your business.",
            preparing_discovery_title: "Preparing intent discovery",
            preparing_discovery_description: "Getting ready to identify the most relevant intent topics...",
            generating_topics_title: "Generating intent topics",
            generating_topics_description: "Your agent is generating relevant intent topics based on your context and goal...",
            failed_title: "Something went wrong while generating the topics...",
            failed_description: "You'll be redirected to the previous page shortly...",

            geo_engine_title: "Select AI engine",
            geo_engine_description: "Choose where you want to run your intent simulations. Select one, multiple engines, or all to get a broader view of your AI visibility.",
            generate: "Generate",
            geo_prompt_warning: "realistic intent-based simulations. <br /> These simulations replicate the kinds  questions and prompts potential might use when searching for about your business.",

            prompt_rquired: "Prompt is required...",
            new_prompt: "New prompt",
            prompt: "Prompt",
            new_prompt_placeholder: "Enter your prompt in plain, natural language.",

            prompt_info: "Prompt info",
            reason_required: "Reason is required...",
            classify_prompt: "Classify prompt",
            why_is_prompt: "Why is the prompt",
            classify_placeholder: "Add a brief explanation for why this prompt is classified as",
            classify_warning: "Why do we ask you to classify the prompt? <br />By classifying a prompt as positive or negative, you help us evaluate the quality and accuracy of AI-generated responses. Your feedback helps us identify what works well, improve generation quality, and fine-tune our models to deliver more relevant and reliable results.",
            POSITIVE: "positive",
            NEGATIVE: "negative",

            delete_prompt: "Delete prompt",
            delete_prompt_desc: "This will permanently delete the prompt, and it will no longer be included in simulations. This action cannot be undone.",

            simulated_prompts: "Simulated prompts",
            simulated_prompts_desc: "AI-generated questions that reflect how people might ask about your content",
            add_custom_prompt: "Add custom prompt",
            gen_prompt_warning: "These prompts represent the types of questions potential customers might ask when looking for information about your business, reflecting their needs, interests, and search intent.",

            preparing_prompt_simulations: "Preparing prompt simulations",
            preparing_prompt_simulations_desc: "Getting ready to generate prompt simulations...",

            running_prompt_simulations: "Creating simulated prompts",
            running_prompt_simulations_desc: "Generating prompts to simulate realistic user interactions",

            select_a_language: "Select a language",
            select_a_language_desc: "Choose the language for your simulations",
            select_language: "Select language",
            select_language_warning: "All generated intent topics, simulated prompts and final simulations will use the selected language to ensure consistency and more relevant results.",

            add_property_geo: "Add your property",
            add_property_geo_desc: "Start with the website you want to improve.",
            add_property_geo_warning: "Your domain will serve as the foundation for all analytics, insights, and optimization actions throughout this process.",
            add_property_geo_warning_validate: "Checking your website’s accessibility and ensuring it’s ready for analysis.",

            failed_to_validate: "Failed to validate the URL...",
            url_non_reachable: "URL is non reachable...",
            unable_to_validate: "Unable to validate the URL...",

            running_sim_title: "Running simulated prompts",
            running_sim_desc: "Our agent is testing your prompts across multiple AI engines to evaluate their responses.",

            overview: "Overview",
            context: "Context",
            topics: "Topics",
            prompts: "Prompts",
            simulation_settings: "Settings",
            actions: "Actions",

            visibility: "Visibility",
            effectiveness: "Effectiveness",
            position: "Position",
            sentiment: "Sentiment",

            up: "UP",
            down: "DOWN",

            is_trending: "is trenging",

            natural: "Natural",
            linear: "Linear",

            select_engines: "Select engines",
            select_prompt: "Select prompt",
            select_metric: "Select metric",

            from: "From",
            to: "To",

            line_style: "Line style",

            select_valid_date: "Select a valid date range...",
            no_data_available_for_params: "No data available for the selected parameters...",

            engine: "Engine",
            engines: "Engines",
            simulations: "simulations",
            simulation: "simulation",

            details: "Details",
            engine_answer: "AI Engine answer",
            citations: "Citations",
            sources: "Sources",
            strengths: "Strengths",
            weaknesses: "Weaknesses",
            improvements: "Suggestions for improvements",

            schedule_settings_title: "Schedule settings",
            every: "Every",
            at: "At",
            schedule_warn: "Geo monitoring will run automatically at the configured interval. Any actions will run only if enabled.",
            run: "Run every",
            day: "Day",
            days: "Days",
            week: "Week",
            weeks: "Weeks",
            month: "Month",
            months: "Months",
            interval_err: "Enter an interval between 1 and",
            time_err: "Time is required...",


            monitoring_title: "GEO Simulation Monitoring",
            monitoring_summary: "Tracks GEO prompt simulation results across the selected AI engines.",
            sim_monitoring_title: "Simulation monitoring",

            select_action_title: "Select an action",
            select_action_desc: "Choose an action to explore its details, review proposed changes, and manage how Abstracht optimizes your website.",

            analysis: "Analysis",
            applied_strategy: "Applied strategy",
            potential_outcome: "Potential outcome",
            optimizations: "Optimizations",
            analyzed_strategies: "Analyzed strategies",

            approach: "Approach",
            evaluation_window_days: "Evaluation window days",
            objective: "Objective",
            success_metrics: "Success metrics",
            confidence: "Confidence",
            high: "High",
            medium: "Medium",
            low: "Low",
            description: "Description",
            estimated_impact: "Estimated impact",
            limitations: "Limitations",
            effort: "Effort",
            expected_benefit: "Expected benefit",
            id: "ID",
            priority: "Priority",
            problem: "Problem",
            reasoning: "Reasoning",
            recommendation: "Recommendation",
            type: "Type"

        },
        ads: {
            title: "Ads",
            subtitle: "AI-Powered Advertising Optimization",
            empty_subtitle: "Create, optimize, and continuously improve your advertising campaigns with AI.",
            quest_title: "What is Ads?",
            quest_answ: "AI-powered advertising helps you create, analyze, and optimize campaigns across advertising platforms. Generate high-intent audiences and keywords, evaluate campaign opportunities, optimize budgets and creatives, and continuously improve performance based on real campaign data.",

            title_required: "Please enter a title",
            desc_required: "Please enter a description",

            new_title: "New Ads Optimization"
        },
        context: {
            title: "Context",
            subtitle: "AI Context & Information",
            empty_subtitle: "Provide the AI with the information and context it needs to understand your brand and create accurate simulations.",
            quest_title: "What is the context?",
            quest_answ: "Context provides the information the AI uses to understand your company, products, services, audience, and positioning. It gives AI tools the relevant information they need to create more consistent, accurate, relevant, and realistic simulations.",
            title_required: "Please enter a title",
            desc_required: "Please enter a description",
            new_title: "New context",
            name_required: "Context title is required",
            desc_required: "Context description is required",
            delete_title: "Delete context",
            delete_desc: "Deleting this context will permanently remove the information it contains. Any simulations, campaigns, or optimizations using it will no longer have access to this information. This action cannot be undone.",

            delete_title_source: "Delete source",
            delete_desc_source: "Deleting this context source will permanently remove the information it contains. Any simulations, campaigns, or optimizations using it will no longer have access to this information. This action cannot be undone.",

            title_placeholder: "Ex: Product Info",
            description_placeholder: "Ex: Product page and description",
            description_placeholder_2: "Ex: A detailed description of the product...",
            open_context_title: "Build a complete context",
            open_context_description: "Bring together relevant sources, documents, and data to create a rich, reliable context. The more relevant information you provide, the better your context can capture the full picture and deliver more accurate, meaningful results.",
            add_new_source_title: "Add a new source",
            add_new_source_description: "Connect different sources to build a richer, more complete context.",
            context_logs_title: "Logs",
            loading_logs: "Loading logs...",
            logs_timestamp: "Timestamp",
            logs_message: "Message",
            source_urls: "Sources",
            created_at: "Created at",
            last_synced_at: "Last synced at",
            status: "Status",
            source_type: "Source type",
            id: "ID",
            QUEUED: "QUEUED",
            RUNNING: "RUNNING",
            FAILED: "FAILED",
            COMPLETED: "COMPLETED",
            view_logs_btn: "View logs",
            source_overview: "Source overview",
            total_pages: "Total pages",
            summarized_pages: "Summarized pages",
            total_chunks: "Total chunks",
            last_updated: "Last updated",
            indexed_at: "Indexed at",
            chunks: "Chunks",
            custom_source: "Custom source",
            read: "Read",
            one_page_summary: "One page summary",
            page_summaries: "Page summaries",
            no_summary_available: "No summary available for this page",
            initializing: "Initializing...",
            processing: "Processing...",
            extracting: "Extracting...",
            indexing: "Indexing...",
            building: "Building source...",
            almost_done: "Almost done...",
            update_context_title: "Updates context",
            title_required: "Title is required",
            text_required: "Text is required",
            text: "Text",
            set_custom_context: "Set custom context",
            loading_content: "Loading content...",
            please_select_url: "Please select at least one URL.",
            add_url_title: "Add website URL",
            add_utl_description: "Enter your website URL to let the system scan and extract relevant information. You can choose to crawl the entire website or select specific pages.",
            urls_appear_title: "URLs will appear here...",
            url_warning: "Some websites may restrict access, preventing us from extracting or analyzing their content.",
            start_web_extraction: "Start web extraction",
            select_all: "Select all",
            deselect_all: "Deselect all",
            please_select_file: "Please select at least one file.",
            failed_upload: "Failed to upload files...",
            add_docs_title: "Add your documents & files",
            add_docs_description: "Upload your documents and files to let the system extract and process relevant information. You can select multiple files to include in your knowledge base.",
            select_files: "Select files",
            selected_files_appear: "Selected files will appear here...",
            remove_all: "Remove all",
            selected: "selected",
            remove: "Remove",
            upload_documents: "Upload documents",
            new_source: "New source",
            source_not_available: "source is not available yet.",
            website: "Website",
            documents: "Documents",
            custom: "Custom"
        },
        properties: {
            title: "Properties",
            subtitle: "Manage your properties and power your growth agents",
            empty_subtitle: "Connect your properties to unlock AI-powered growth",
            quest_title: "What are properties?",
            quest_answ: "Properties are the websites your Abstracht agents monitor and optimize across all modules. Connect a property to track performance, uncover opportunities, and turn growth strategies into action.",

            tag_not_installed: "Tag not installed",

            name_required: "Property name is required...",
            base_url_required: "Base URL is required...",
            domain_required: "Domain is required...",


            new_title: "New property",
            base_url: "Base URL",
            domain: "Domain",
            verify_domain_warn: " Please verify that the domain is correct and points to the website you want to monitor and optimize.",

            deployment: "Deployment",
            enabled: "Enabled",
            disabled: "Disabled",
            deployment_warn: "Deployment is enabled. Abstracht agents can make changes directly to your website.",

            update_title: "Update property",

            delete_title: "Delete property",
            delete_desc: "This will permanently delete the property and all associated information, and discontinue any active monitoring or execution. Once deleted, this action cannot be undone.",

            install_tag_title: "Install the Abstracht tag",
            install_on: "Install the tag on",
            to_enable: "to enable monitoring and automated optimizations.",
            not_installed: "Tag is not installed",
            tag_warn_one: "The tag allows Abstracht's AI agents to monitor website performance and deploy optimizations directly to your website, according to your permissions and settings.",
            tag_warn_two: "Need help with the installation? Check the guide",


            how_to_title: "How to install the tag?",
            how_to_desc:
                "Follow the instructions below to install the Abstracht tag on your website. Choose the setup that matches your website technology.",

            how_to_step_copy_title: "1. Copy your installation tag",
            how_to_step_copy_desc:
                "Copy the code below. It contains the identifier for this property, so make sure you use the correct tag for your website.",

            how_to_step_type_title: "2. Choose your website type",
            how_to_tab_standard: "Standard website",
            how_to_tab_spa: "Single-page app (SPA)",
            how_to_tab_tagmanager: "Tag manager",

            how_to_standard_subtitle: "For traditional websites",
            how_to_standard_step_1:
                "Open your website's HTML template or shared layout file.",
            how_to_standard_step_2:
                "Find the closing",
            how_to_standard_step_3:
                "Paste the installation tag just before",
            how_to_standard_step_4:
                "Save your changes and publish your website.",
            how_to_standard_desc:
                "Add the tag to a shared layout or global template so it is included on all the pages where you want Abstracht to operate. You usually do not need to add it individually to every page.",

            how_to_spa_subtitle:
                "For React, Vue, Angular, and other SPAs",
            how_to_spa_desc:
                "A single-page application (SPA) can navigate between pages without reloading the entire website. Add the tag to the main HTML document so it can be loaded as part of your app.",
            how_to_spa_step_1:
                "Open your application's main HTML file. In React, this is often public/index.html or index.html, depending on your project setup.",
            how_to_spa_step_2:
                "Paste the installation tag inside the",
            how_to_spa_step_3:
                "Save your changes and rebuild or deploy your application as required by your framework.",
            how_to_spa_step_4:
                "Publish your changes to your live website.",
            how_to_spa_desc_2:
                "Add the tag to the main HTML document only once. If you use client-side routing, any additional setup needed to handle navigation between routes depends on your application's tracking integration.",

            how_to_tagmanager_subtitle:
                "For websites using a tag manager",
            how_to_tagmanager_step_1:
                "Open your tag manager, such as Google Tag Manager.",
            how_to_tagmanager_step_2:
                "Create a new tag using a custom HTML option, if supported.",
            how_to_tagmanager_step_3:
                "Paste the Abstracht installation tag into the tag configuration.",
            how_to_tagmanager_step_4:
                "Configure the trigger so the tag runs on the pages where you want it installed.",
            how_to_tagmanager_step_5:
                "Save and publish your tag manager container.",
            how_to_tagmanager_desc:
                "Make sure your tag manager changes are published, not just saved as a draft.",

            how_to_step_publish_title: "3. Publish your changes",
            how_to_step_publish_desc:
                "Save your changes and publish your website. Make sure the installation tag is included on the pages where you want Abstracht to operate.",

            how_to_support:
                "If you need help installing the tag or encounter any problems, contact us at",


            connection_title: "Connection",

            connected_status: "Connected",
            connected_status_desc: "Tag is detected on yoyr website",

            not_installed_status: "Not installed",
            not_installed_status_desc: "Install the Abstracht tag to enable website connectivity",
            not_installed_status_desc_geo: "Install the Abstracht tag to connect your website. <br/>In the meantime, you can still monitor its performance.",
            connection_error_status: "Connection error",
            connection_error_status_desc: "The tag encountered an issue. Check your installation",

            verification_title: "Verification",

            verified_status: "Verified",
            verified_status_desc: "Website ownership was confirmed on",

            verification_failed_status: "Verification failed",
            verification_failed_status_desc: "Ownership could not be verified. Check your verification settings.",

            pending_verification_status: "Pending verification",
            pending_verification_status_desc: "Complete verification to confirm website ownership",

            deployment_title: "Deployment",

            deployment_enabled_status: "Enabled",
            deployment_enabled_status_desc: "Abstracht agents can apply changes directly to your website.",

            deployment_disabled_status: "Disabled",
            deployment_disabled_status_desc: "Enable deployment to allow Abstracht agents to apply changes directly to your website.",

            last_activity_title: "Last tag activity",
            last_activity_date_desc: "Date of last activity",
            last_activity_time_desc: "Time of last activity",

            verify_domain_desc: "Confirm website ownership to complete verification.",
            verify_domain_btn: "Verify",

            enable_deployment_desc: "Allow Abstracht agents to apply changes directly to your website.",
            enable_deployment_btn: "Enable",

            verify_domain_title: "Verify domain ownership",
            type: "Type",
            data: "Data",
            verify_domain_own_warn: "Verifying your domain confirms that you own or control the website, allowing Abstracht to securely manage your property. DNS record changes may take a few minutes to propagate.",
            provider_message: "Provider message",
        }

    },
    it: {
        help: 'Hai bisogno di aiuto? Contatta <a href="mailto:support@abstracht.com">support@abstracht.com</a>',
        no_data_found: "Nessun dato trovato...",
        yes: "Sì",
        save: "Salva",
        close: "Chiudi",
        delete: "Elimina",
        create: "Crea",
        search_filter: "Filtra i dati cercando...",
        reload: "Ricarica",
        no_data_found_by_search: "Nessun dato trovato corrispondente alla tua ricerca...",
        no_data: "Nessun dato disponibile...",
        name: "Nome",
        full_name: "Nome e cognome",
        title: "Titolo",
        description: "Descrizione",
        mandatory_field: "Campo obbligatorio",

        type_confirm: "Per confermare, digita",
        documentation: "Documentazione",

        select: "Seleziona",
        selected: "selezionato",
        create_new: "Crea nuovo",
        here: "qui",

        created_at: "Creato il",
        updated_at: "Aggiornato il",
        no_logs: "Nessun log disponibile",
        log: "Log",
        error_occurred: "Si è verificato un errore",
        connect: "Connetti",
        disconnect: "Disconnetti",
        no_abilities: "Nessuna abilità trovata...",
        loading: "Caricamento...",
        different_version: "La versione distribuita e quella collegata differiscono. Ti consigliamo di riconnetterti per sincronizzarle.",
        reasoning: "reasoning",

        insufficient_funds: "Il saldo del tuo portafoglio è insufficiente. Aggiungi fondi o abilita il ricaricamento automatico.",
        open_directory: "Apri directory",
        stop: "Ferma",
        send: "Invia",
        cancel: "Annulla",
        next: "Avanti",
        back: "Indietro",

        public: "Pubblico",
        custom: "Personalizzato",

        copy: "Copia",
        copied: "Copiato",

        website: {
            navbar: {
                dashboard: "Dashboard",
                waitlist: "Lista d'attesa",
                start_now: "Inizia ora",
                login: "Accedi"
            },
            sidebar: {
                abilities: "Abilità",
                fine_tuning: "Fine-tuning e agenti",
                team_managment: "Gestione del team",
                pricing: "Prezzi"
            },
            footer: {
                all_rights: "Tutti i diritti riservati.",
                legal: "Note legali",
                privacy: "Informativa sulla privacy",
                terms: "Termini e condizioni",
                t0r: 'Abstracht è una società <a href="https://t0.abstracht.com">Type Zero</a>'
            },

            main_title: "Costruisci la tua IA",
            main_subtitle: "Dai ai modelli esperti capacità illimitate, poi fai un passo indietro.",
            build_software: "Crea software",
            create_agents: "Crea agenti",
            fine_tune: "Fine-tuning dei LLM",
            centralized_search: "Ricerca centralizzata",
            team_orch: "Orchestrazione del team",
            input_placeholder: "Descrivi cosa vuoi costruire...",
            phrases: [
                "Genera un report finanziario consolidato del Q4 includendo la posizione di tesoreria, le previsioni di flusso di cassa e l’analisi degli scostamenti tra tutte le filiali.",
                "Analizza il churn dei clienti negli ultimi 12 mesi e identifica i principali fattori comportamentali e di ricavo che influenzano la retention.",
                "Crea un workflow standardizzato di onboarding per nuovi clienti enterprise, includendo controlli di conformità e flussi di approvazione interni.",
                "Automatizza la riconciliazione delle fatture confrontando i record ERP con le transazioni bancarie e segnalando le incoerenze.",
                "Distribuisci un agente AI di supporto addestrato sulla documentazione interna per gestire richieste di assistenza di primo livello.",
                "Redigi una policy di governance dei dati conforme al GDPR che copra accesso, archiviazione, conservazione e integrazioni di terze parti.",
                "Prevedi i ricavi per il prossimo anno fiscale usando performance storica, trend di stagionalità e pipeline attuale.",
                "Ottimizza la logistica della supply chain identificando colli di bottiglia in approvvigionamento, magazzino e consegna finale.",
                "Genera un executive summary pronto per il consiglio che includa KPI operativi, esposizione al rischio e iniziative strategiche.",
                "Monitora i cambiamenti normativi nei mercati UE e aggiorna automaticamente la documentazione interna di conformità."
            ],

            pricing: {
                title: "Prezzi",
                subtitle: "Consulta i prezzi per piani personali, business ed enterprise",
                monthly: "Mensile",
                yearly: "Annuale",
                custom: "Personalizzato",
                more_info: 'Maggiori informazioni sui prezzi sono disponibili <a href="https://www.abstracht.com/pricing" target="_blank" rel="noopener noreferrer">qui</a>'
            },

            how_payments_work: {
                one_title: "Come funzionano i pagamenti",
                one_subtitle: "I pagamenti dipendono dai servizi utilizzati. Il tuo account funziona con un sistema di wallet prepagato. Puoi aggiungere fondi con carta di credito (supporto SEPA in arrivo). Il saldo viene utilizzato automaticamente durante l’uso dei servizi.",
                two_title: "Utilizzo AI",
                two_subtitle: "L’uso dell’AI (LLM) viene addebitato in tempo reale in base ai token di input e output elaborati. Il prezzo varia in base al modello.",
                three_title: "Abilità",
                three_subtitle: "Le abilità vengono addebitate per esecuzione. Il prezzo è calcolato in base al tempo di esecuzione, uso di compute e numero di richieste.",
                four_title: "Azioni",
                four_subtitle: "Le azioni una tantum costano $0.01 per esecuzione. Le azioni programmate costano $0.01 al giorno mentre sono attive.",
                five_title: "Cosa succede se il tuo wallet non ha credito?",
                five_subtitle: "Se il saldo del wallet arriva a zero, tutti i servizi (AI, Abilità e Azioni) si interrompono immediatamente. Per riprendere l’uso è necessario ricaricare il wallet."
            },

            use_cases: {
                use_case_data: [
                    {
                        kicker: "Dati",
                        title: "Accesso unificato ai dati",
                        desc: "Importa facilmente dati da più fonti, crea connettori personalizzati o distribuisci database preconfigurati con un solo clic. I dati vengono elaborati e strutturati in modo che sia tu che il modello possiate leggerli e recuperarli in modo efficiente."
                    },
                    {
                        kicker: "Intelligenza",
                        title: "Gestione intelligente dei LLM",
                        desc: "Seleziona diversi LLM e scegli se ottimizzarli per casi d’uso specifici. Ogni LLM include una Memoria Cognitiva integrata che gli consente di recuperare informazioni rilevanti quando necessario."
                    },
                    {
                        kicker: "Scala",
                        title: "Scalabilità del team senza sforzo",
                        desc: "Crea team e utenti e scala il tuo LLM personalizzato su cluster autoscalabili senza sforzo, garantendo prestazioni e accessibilità per tutti i membri."
                    }
                ]
            },

            ai_enterprise: {
                kicker: "AI PER ENTERPRISE",
                title: "Distribuisci l’AI su larga scala",
                subtitle: "Crea, integra e scala soluzioni AI in tutta la tua organizzazione."
            },
            sales: {
                contact_btn: "Contattaci",
                subtitle: "Ti risponderemo il prima possibile",
                message_placeholder: "Lascia un breve messaggio...",
                email_err_mex: "L'email è obbligatoria",
                name_err_mex: "Nome e cognome sono obbligatori",
                req_success: "Abbiamo ricevuto la tua richiesta!",
                thanks: "Grazie per averci contattato, ti risponderemo entro 1–2 giorni lavorativi.",
                back_home_btn: "Torna alla homepage",
            }
        },
        register_form: {
            create_account: "Crea un account",
            newsletter: "Desidero ricevere notizie e aggiornamenti.",
            privacy_continue: 'Continuando accetto la <a href="/privacy">Informativa sulla privacy </a> | <a href="/terms-and-conditions">Termini e condizioni</Link>',
            with_google: "con Google",
            name: "Nome",
            surname: "Cognome",
            phone: "Telefono",
            repeat_password: "Ripeti password",
            button_register: "Registrati",
            already_registered: "Sei già registrato?",
            go_login: "Accedi",
            email_format: "Il formato dell'email non è corretto...",
            password_err: "La password deve essere lunga almeno 10 caratteri e contenere lettere maiuscole, minuscole, caratteri speciali e numeri..",
            password_match: "Le password non coincidono...",
            red_fields: "Controlla i campi obbligatori...",
            email_already_present: "Email già presente...",
            errors_back: "È stato rilevato un errore... riprova",
            problem_back: "C'è un problema con l'accesso... riprova tra qualche minuto",
            terms_conditions_desc: "Ho letto e accetto i",
            t_c: "Termini e condizioni",
            privacy_policy_desc: "Ho letto e accetto la",
            p_p: "Informativa sulla privacy",
            button_login: "Accedi",
            dont_have_account: "Non hai un account?",
            go_register: "Registrati",
            invalid_email_pass: "email o password non validi... riprova",
            welcome_to: "Benvenuto su",
            description_one: "Progettato per operazioni su grandi volumi di dati e orchestrazione cloud intelligente, Abstracht unisce prestazioni e semplicità con storage velocissimo, potenza di calcolo e intelligenza vettoriale gestita da un’IA dedicata.",
            welcome_back: "Bentornato!",
            update_mex: "È arrivato il Python SDK di Abstracht — installalo oggi e integra tutto senza sforzo."
        },
        verification: {
            title: "Verifica della tua email...",
            verified_title: "Email verificata",
            verified_subtitle: "Il tuo account è stato verificato con successo. Verrai reindirizzato a breve.",
            failed_verified_title: "Verifica fallita...",
            failed_verified_subtitle: "Il link di verifica non è valido o è scaduto.",
            verify_email_title: "Verifica la tua email!",
            verify_email_subtitle: "Abbiamo inviato un link di verifica a ",
            verify_email_message: "Controlla la tua casella di posta (e la cartella spam) e clicca sul link per attivare il tuo account.",
            resend_btn: "Reinvia email",
            email_sent: "Email inviata con successo!",
            email_sent_sub: "Controlla la tua casella di posta."
        },
        onboarding: {
            five_options: "Devi selezionare tre opzioni...",
            one_option: "Devi selezionare un'opzione...",
            welcome: "Benvenuto",
            welcome_sub: "Configuriamo il tuo account. Ci vorrà solo un momento.",
            ready: "Sono pronto",
            continue: "Continua",
            back: "Indietro",
            language: {
                title: "Scegli una lingua",
                subtitle: "Potrai sempre cambiarla in seguito",
                warning: "La maggior parte degli LLM è addestrata principalmente su dati in lingua inglese, quindi, anche se selezioni un’altra lingua, il modello potrebbe comunque rispondere in inglese in alcuni casi."
            },
            personal_info: {
                phone_prefix_required: "Il prefisso telefonico è obbligatorio...",
                phone_required: "Il numero di telefono è obbligatorio...",
                invalid_phone: "Formato del numero di telefono non valido",
                street_required: "La via è obbligatoria...",
                street_n_required: "Il numero civico è obbligatorio...",
                city_required: "La città è obbligatoria...",
                country_required: "Il paese è obbligatorio...",

                title: "Profilo",
                subtitle: "Completiamo la configurazione del tuo profilo",
                phone: "Telefono",
                street_n: "Via e numero civico",
                city: "Città",
                country: "Paese",
                no_countries: "Nessun paese trovato...",
                billing_matches: "Le informazioni di fatturazione corrispondono ai dati forniti",
                billing_title: "Informazioni di fatturazione",
                billing_subtitle: "Aggiungi i dettagli di fatturazione"
            },

            experience: {
                title: "Scegli la tua esperienza",
                subtitle: "Potrai sempre cambiarla in seguito",
                light: "Chiaro",
                dark: "Scuro",
                system: "Sistema"
            },

            about_you: {
                title: "Parliamo di te...",
                subtitle: "Cosa ti descrive meglio",
                about_you_options: [
                    { value: "developer", label: "Sviluppatore / Ingegnere" },
                    { value: "designer", label: "Designer" },
                    { value: "product_manager", label: "Product Manager" },
                    { value: "it_devops", label: "IT / DevOps" },

                    { value: "marketing", label: "Professionista Marketing" },
                    { value: "sales", label: "Professionista Vendite" },
                    { value: "operations", label: "Operazioni" },
                    { value: "finance", label: "Finanza" },
                    { value: "hr", label: "HR / Risorse Umane" },
                    { value: "customer_support", label: "Assistenza Clienti" },

                    { value: "founder", label: "Fondatore / Co-Fondatore" },
                    { value: "executive", label: "Dirigente (CEO, CTO, ecc.)" },
                    { value: "manager", label: "Manager" },

                    { value: "creator", label: "Creatore di contenuti" },
                    { value: "writer", label: "Scrittore" },
                    { value: "artist", label: "Artista" },

                    { value: "tradesperson", label: "Artigiano specializzato" },
                    { value: "mechanic", label: "Meccanico" },
                    { value: "barber", label: "Barbiere / Parrucchiere" },

                    { value: "hospitality_worker", label: "Lavoratore nel settore ospitalità" },
                    { value: "retail_worker", label: "Lavoratore nel commercio al dettaglio" },
                    { value: "driver", label: "Autista / Consegne" },

                    { value: "student", label: "Studente" },
                    { value: "teacher", label: "Insegnante / Educatore" },

                    { value: "freelancer", label: "Freelancer / Lavoratore autonomo" },
                    { value: "employee", label: "Dipendente" },

                    { value: "other", label: "Altro" }
                ]
            },

            team: {
                title: "Informazioni sul tuo team...",
                subtitle: "Quante persone lavoreranno con te",
                about_you_options: [
                    { value: "only_1", label: "Solo io" },
                    { value: "1_5", label: "1 a 5 persone" },
                    { value: "5_10", label: "5 a 10 persone" },
                    { value: "10_25", label: "10 a 25 persone" },
                    { value: "25_100", label: "25 a 100 persone" },
                    { value: "100_200", label: "100 a 200 persone" },
                    { value: "200_more", label: "più di 200" }
                ]
            },

            payment: {
                title: "Completa il checkout",
                subtitle: "Completa il pagamento per il tuo abbonamento. <br />Potrai sempre modificarlo nella sezione fatturazione.",
                checkout_for: "Checkout per",
                summary: "Riepilogo pagamento",
                ammount: "Importo",
                next_payment: "Prossimo pagamento",
                date_info: "La data del prossimo pagamento è nel formato: GG/MM/AAAA",
                interval: "Intervallo",
                recurring: "Ricorrente"
            },

            done: {
                title: "Sei pronto!",
                subtitle: "Hai completato la configurazione e puoi iniziare!",
                open_dashboard: "Apri dashboard"
            }
        },
        payments: {
            label: "Etichetta metodo di pagamento",
            label_required: "L'etichetta del metodo di pagamento è obbligatoria",
            card_details: "Dettagli della carta",
            card_details_required: "I dettagli della carta sono obbligatori",
            sensitive_mex: 'Nessuna informazione sensibile di pagamento viene memorizzata sui nostri server. Tutti i pagamenti sono elaborati in modo sicuro da <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">Stripe</a>, che utilizza crittografia standard del settore e rispetta rigorosi standard di sicurezza per proteggere i tuoi dati.',
            pay_continue: "Paga e continua"
        },
        logout_modal: {
            title: "Sei sicuro di voler uscire?",
            subtitle: "Disconnettiti da Abstracht come "
        },
        sidebar: {
            create: "Crea",
            manage: "Gestisci",
            monitor: "Monitora",
            organizations: "Organizzazioni",
            members: "Membri",
            api_keys: "Chiavi API",
            storage: "Archiviazione",
            billing: "Fatturazione",
            analytics: "Analisi",
            logs: "Log",
            chat: "Chat",
            build: "Crea",
            playground: "Sperimentazione",
            chat_history: "Cronologia chat",
            abilities: "Abilità",
            actions: "Azioni",
            apps: "Applicazioni",
            organization: "Organizzazione",
            admin_panel: "Pannello di amministrazione",

            alert_payment: {
                title: "Configura il pagamento",
                subtitle: "Aggiungi un metodo di pagamento per iniziare",
                btn: "Aggiungi metodo di pagamento"
            },

            alert_abilities: {
                title: "Ti servono più abilità?",
                subtitle: "Ottieni abilità predefinite dal nostro catalogo pubblico.",
                btn: "Apri directory"
            },

            language: "Lingua",
            workspace: "Area",
            theme: "Tema",
            profile: "Profilo",
            logout: "Esci"
        },
        profile: {
            title: "Modifica profilo",
            name: "Nome",
            surname: "Cognome",
            email: "Email",
            account_id: "ID account",
            info: "La tua email aiuta gli altri a riconoscerti e identificarti rapidamente quando collaborano con te."
        },
        delete_modal: {
            delete: "Elimina",
            error_val_match: "Il valore inserito non corrisponde. Per favore digita il nome esatto per confermare.",
        },
        organizations: {
            title: "Organizzazioni",
            subtitle: "Visualizza e gestisci tutte le organizzazioni registrate nel sistema.",
            empty_subtitle: "Crea una nuova organizzazione e inizia a scalare l’IA tra i tuoi team",
            quest_title: "Cos’è un’organizzazione?",
            quest_answ: "Un’organizzazione è un hub collaborativo per il tuo spazio di lavoro. Che rappresenti un team specifico, un dipartimento o un gruppo di progetto, ti consente di centralizzare le risorse AI, gestire i membri e scalare i tuoi flussi di lavoro insieme in un unico posto.",

            org_name_required: "Il nome dell’organizzazione è obbligatorio",
            org_desc_required: "La descrizione dell’organizzazione è obbligatoria",
            new_organization: "Nuova organizzazione",

            manage_organization: "Gestisci organizzazione",
            settings: "Impostazioni",
            members: "Membri",
            close_org: "Chiudi organizzazione",

            warning_points: [
                "Questa organizzazione diventerà permanentemente non disponibile per tutti i membri.",
                "Tutti i membri verranno rimossi dall’organizzazione.",
                "Questa organizzazione diventerà permanentemente non disponibile per tutti gli utenti.",
                "Tutte le abilità collegate a questa organizzazione verranno rimosse in modo permanente.",
                "Tutte le azioni collegate a questa organizzazione verranno interrotte e rimosse in modo permanente.",
                "Tutti i dati associati (chat, codice, URL, connessioni ecc.) verranno eliminati definitivamente."
            ],

            all_warnings_mex: "Tutti gli avvisi devono essere selezionati",
            warning_del: 'L’eliminazione di questa organizzazione è <strong>permanente</strong> e <strong>irreversibile</strong>. Una volta eliminata, sarà <strong>completamente rimossa dal sistema</strong>, incluse tutte le versioni, i dati associati (chat, codice, URL, ecc.) e qualsiasi connessione utente.<br /><br /><strong>QUESTA AZIONE NON PUÒ ESSERE ANNULLATA</strong>',
            confirm_title: "Conferma richiesta",
            confirm_subtitle: "Conferma di aver letto e accettato i termini.",
            i_confirm: "Confermo e voglio procedere"
        },
        members: {
            title: "Membri",
            subtitle: "Visualizza e gestisci tutti i membri registrati e i loro livelli di accesso.",
            empty_subtitle: "Crea nuovi membri e assegnali a un’organizzazione.",
            quest_title: "Chi è un membro?",
            quest_answ: "Un membro è un singolo utente. Puoi assegnarlo alle organizzazioni, definire i ruoli e controllare i livelli di accesso per gestire i permessi.",

            role_options: {
                owner: "Gli Owner hanno il pieno controllo dell’organizzazione, dalla gestione del team alle configurazioni. Assegna questo ruolo solo a chi richiede accesso completo.",
                manager: "I Manager si occupano delle operazioni del team e della gestione dei membri, ma hanno accesso limitato alle configurazioni tecniche dei modelli e al fine-tuning.",
                developer: "Gli Developer hanno accesso tecnico completo per creare, fare fine-tuning e assegnare modelli, ma non possono gestire i membri del team o le impostazioni dell’organizzazione.",
                member: "I membri hanno accesso standard per utilizzare gli strumenti esistenti e creare flussi di lavoro personali, senza permessi amministrativi o di configurazione dei modelli."
            },
            user: "Utente",
            org_roles: "Organizzazioni e ruoli",
            invite_member: "Invita un membro del team",
            role: "Ruolo",
            more_info: "Per maggiori informazioni clicca",
            invite: "Invita",
            all_org_role: "Tutte le organizzazioni devono avere un ruolo",
            update_title: "Aggiorna membro del team",
            org_roles: "Organizzazioni e ruoli",

            warning_permissions: `<strong>Azione non consentita</strong><br />Non hai i permessi per aggiornare i membri`,

            warning_creator: "<strong>Azione non consentita</strong><br /> Questo membro è il creatore dell’organizzazione e non può essere modificato o rimosso. Il creatore ha privilegi amministrativi completi e la sua rimozione potrebbe compromettere il controllo degli accessi o la proprietà dell’organizzazione. Per effettuare modifiche, puoi trasferire la proprietà o contattare l’amministratore di sistema.",

            warning_remove: '<strong>Stai per rimuovere questo membro dall’organizzazione.</strong><ul><li>Il membro perderà l’accesso a tutti gli strumenti, workflow e dati associati a questa organizzazione.</li><li>Questa azione non può essere annullata da questa finestra.</li><li>Per ripristinare l’accesso, il membro dovrà essere nuovamente aggiunto all’organizzazione</li></ul>'
        },
        api_keys: {
            title: "Chiavi API",
            subtitle: "Visualizza e gestisci tutte le chiavi API. Monitora l’utilizzo, controlla gli accessi e integra in modo sicuro i servizi AI nei tuoi sistemi.",
            empty_subtitle: "Crea una chiave API e inizia a integrare l’AI nelle tue applicazioni.",
            quest_title: "Cosa sono le chiavi API?",
            quest_answ: "Le chiavi API sono credenziali sicure utilizzate per autenticare le tue applicazioni quando accedono ai servizi AI. Organizzando il tuo workspace, puoi creare, gestire e monitorare le chiavi API tra diversi team, progetti o ambienti.",

            new_item: "Nuova chiave API",
            api_key: "Chiave API",
            api_warning: "Questa chiave viene mostrata una sola volta, salvala in modo sicuro e mantienila privata.",
            exp_date: "Data di scadenza",

            name_required: "Il nome della chiave API è obbligatorio",
            desc_required: "La descrizione della chiave API è obbligatoria",

            exp_date_mex: "Seleziona una data di scadenza",

            expired_date_msg: "La data di scadenza non può essere nel passato",

            delete_title: "Elimina chiave API",
            delete_desc: "L’eliminazione di questa chiave API revocherà permanentemente l’accesso. Qualsiasi applicazione o servizio che la utilizza smetterà immediatamente di funzionare. Questa azione non può essere annullata."
        },
        storage: {
            title: "Archiviazione",
            subtitle: "Visualizza e gestisci tutti i file e le cartelle.",
            new_folder: "Nuova cartella",
            upload_files: "Carica file",
            delete_folder: "Una volta eliminata, questa cartella e tutto il suo contenuto verranno eliminati definitivamente.",
            delete_file: "Una volta eliminato, questo file verrà rimosso in modo permanente.",
            folder_name_required: "Il nome della cartella è obbligatorio",
            org_required: "L’organizzazione è obbligatoria",
            folder_alredy_present: "La cartella esiste già. Usa un altro nome.",
            folder_name: "Nome cartella",
            share_with_org: "Condividi con un’organizzazione",
            share_warning: "Assegnare questa cartella a un’organizzazione la renderà accessibile a tutti i suoi membri.",
            max_files_upload: "Puoi caricare un massimo di 10 file",
            min_files_upload: "È richiesto almeno 1 file",
            share_files_warning: "Assegnare i file a un’organizzazione li renderà accessibili a tutti i suoi membri.",
            click_drag: "Clicca o trascina i file qui"
        },
        billing: {
            title: "Fatturazione",
            wallet: "Portafoglio",
            usage: "Utilizzo",
            payment_info: "Informazioni di pagamento",
            usage_activity: "Attività di utilizzo",
            download_csv: "Scarica CSV",
            add_card: "Aggiungi carta",
            open_wallet: "Apri portafoglio carte",
            credit_balance: "Saldo crediti",
            top_up: "Ricarica",
            payment_activity: "Attività di pagamento",
            min_5_credit: "È richiesto un minimo di $5.00 per l’importo del credito",
            min_5_threshold: "È richiesto un minimo di $5.00 per la soglia",
            min_10_threshold: "È richiesto un minimo di $10.00 per la soglia",
            pyment_method_name_required: "Il nome del metodo di pagamento è obbligatorio",
            add_credits: "Aggiungi crediti",
            credits: "Crediti",
            pay_method_name: "Nome metodo di pagamento",
            card_details: "Dettagli carta",
            automatic_topup: "Ricarica automatica?",
            when_below: "Quando il saldo scende sotto",
            bring_up: "Riporta il saldo a",
            add_payment_method: "Aggiungi metodo di pagamento",
            default: "Predefinito",
            set_default: "Imposta come predefinito",
            your_card_wallet: "Il tuo portafoglio carte",
            add_new_card: "Aggiungi nuova carta",
            default_card: "Carta predefinita",
            delete_payment_method: "Eliminare il metodo di pagamento?",
            delete_card_warning: "Stai per eliminare questo metodo di pagamento. Questa azione non può essere annullata e la carta verrà rimossa definitivamente dal tuo account."
        },
        analytics: {
            title: "Analisi",
            api_requests: "Richieste API",
            abilities: "Abilità",
            actions: "Azioni",
            total_requests: "Richieste totali",
            activity_logs: "Log attività",
        },
        logs: {
            title: "Log",
            subtitle: "Visualizza tutti i log e monitora qui lo stato degli eventi.",
            empty_subtitle: "Non ci sono ancora log. Inizia a tracciare gli eventi qui.",
            quest_title: "Cos’è un log?",
            quest_answ: "I log registrano eventi importanti, come la creazione di una chiave API, di un’organizzazione o il caricamento di un file. In questo modo puoi monitorare progressi e stati.",
        },
        chat_history: {
            title: "Cronologia chat",
            empty_subtitle: "Tutte le tue conversazioni appariranno qui una volta che inizierai una chat.",
            quest_title: "Cosa sono le chat?",
            quest_answ: "Le chat sono le tue conversazioni registrate con il sistema. Ti aiutano a tenere traccia delle interazioni passate, rivedere i messaggi e gestire il tuo flusso di lavoro in modo efficiente.",
            used_models: "Modelli utilizzati",
            delete_title: "Eliminare la chat?",
            delete_warning: "Questa chat verrà eliminata definitivamente. Questa azione non può essere annullata."
        },
        actions: {
            title: "Azioni",
            subtitle: "Visualizza, gestisci e monitora tutte le tue azioni in un unico posto.",
            empty_subtitle: "Automatizza i tuoi task creando azioni che possono essere eseguite istantaneamente o secondo una pianificazione.",
            quest_title: "Cos’è un’azione?",
            quest_answ: "Usa le azioni basate sull’AI per automatizzare attività ripetitive e semplificare i tuoi processi. Possono essere attivate su richiesta oppure programmate per essere eseguite automaticamente in background.",

            delete_title: "Eliminare l’azione?",
            delete_warning: "Questa azione verrà eliminata definitivamente. Questa operazione non può essere annullata.",

            action_title_req: "Il titolo dell’azione è obbligatorio",
            action_desc_req: "La descrizione è obbligatoria",
            desc_too_long: "La descrizione dell’azione è troppo lunga. Massimo 300 caratteri.",

            create_new_action: "Crea nuova azione",
            desc_placeholder: "Descrivi cosa fa questa azione...",

            trigger_type: "Tipo di trigger",
            last_run_status: "Stato ultima esecuzione",
            last_run: "Ultima esecuzione",

            scheduled: "Programmato",
            one_time_run: "Esecuzione una tantum",

            interval_req: "L’intervallo è obbligatorio",
            repeat_req: "La ripetizione è obbligatoria",

            save_run_action: "Salva ed esegui azione",

            interval: "Intervallo",
            repeat_every: "Ripeti ogni",

            minutes: "Minuti",
            hours: "Ore",
            days: "Giorni",
            weeks: "Settimane",
            months: "Mesi",

            private_action_warning: "Questa azione è privata e accessibile solo dal tuo account. Usala per test o scopi interni. Puoi pubblicarla successivamente nell’organizzazione.",
            public_action_warning: "Questa azione verrà pubblicata globalmente per tutti gli utenti di Abstracht. Usala per la condivisione con la community. Assicurati che non contenga dati sensibili.",
            save_run: "Salva ed esegui",
            steps: "Passaggi",
            step: "Passo",
            append_actions: "Aggiungi azione",
            ability: "Abilità",
            action_logs: "Log azione"
        },
        playground: {
            error_gen: "Si è verificato un errore durante la generazione della risposta da parte dell’AI. Riprova.",
            choose_llm_title: "Scegli tra i LLM disponibili",
            sys_inst_title: "Aggiungi istruzioni di sistema",
            new_intruction: "Nuova istruzione",
            instructions: "Istruzioni",
            reset: "Reimposta",

            delete_instruction_title: "Eliminare l’istruzione?",
            delete_instruction_warning: "Questa istruzione verrà eliminata definitivamente. Questa azione NON può essere annullata.",

            web_search: "Ricerca web",
            no_links: "Nessun link selezionato",
            all_abilities: "Tutte le abilità",

            ai_settings: "Impostazioni AI",
            sys_instructions: "Istruzioni di sistema",
            sys_desc: "Definisci la personalità del modello, i limiti e lo stile delle risposte.",
            temperature: "Temperatura",
            reasoning_depth: "Profondità di reasoning",
            open_abilities: "Apri tutte le abilità",
            memory: "Memoria",
            memory_mex: "La memoria consente al modello di ricordare le conversazioni passate. Puoi attivarla o disattivarla in qualsiasi momento.",
            json_mode: "JSON Mode",
            ls_mex: "Le impostazioni vengono salvate nella memoria locale del browser",

            build_title: "Crea su Abstracht",
            more_mex: "Carica altri messaggi....",
            memory_on: "Memoria ON",
            add_files_docs: "File e documenti",

            suggestions: {
                title_one: "Ricerca approfondita",
                subtitle_one: "Sintetizza argomenti complessi in report strutturati usando accesso web in tempo reale.",

                title_two: "Architettura del codice",
                subtitle_two: "Debug di script, refactoring di funzioni o creazione di interi progetti boilerplate.",

                title_three: "Contenuti creativi",
                subtitle_three: "Scrivi newsletter, blog tecnici o copy per social media.",

                title_four: "Analisi dati",
                subtitle_four: "Carica CSV per visualizzare trend ed estrarre insight immediati."
            },

            open_resource: "Apri risorsa",
            search_results: "Risultati di ricerca",
            input_placeholder: "Inizia a scrivere un prompt, premi invio per inviare"
        },
        abilities: {
            title: "Abilità",
            subtitle: "Visualizza, gestisci o importa abilità nel tuo sistema.",

            empty_subtitle: "Crea abilità personalizzate per estendere ciò che la tua AI può fare.",
            quest_title: "Cos’è un’abilità?",
            quest_answ: "Un’abilità permette alla tua AI di interagire con strumenti esterni, servizi o persino dispositivi fisici come robot. Aggiungendo abilità, sblocchi nuove funzionalità che consentono alla tua AI di automatizzare task, integrarsi nei tuoi workflow e operare oltre le sue funzionalità native.",

            ability_name_req: "Il titolo dell’abilità è obbligatorio",
            ability_desc_req: "La descrizione dell’abilità è obbligatoria",
            ab_desc_long: "La descrizione dell’abilità è troppo lunga. Massimo 300 caratteri.",
            one_cat_req: "È richiesta almeno 1 categoria",
            transp_req: "Il tipo di trasporto è obbligatorio",
            tool_req: "È richiesto almeno 1 strumento",
            license_req: "La licenza è obbligatoria",
            region_req: "La regione è obbligatoria",
            endpoint_url_req: "L’URL dell’endpoint è obbligatorio",

            ab_placeholder: "Descrivi cosa consente di fare questa abilità all’AI...",

            build_new_ability: "Crea nuova abilità",
            build_py: "Crea la tua abilità usando Python e FastAPI.",
            build_js: "Crea la tua abilità usando Node.js e Express.",

            runtime: "Runtime",
            source_url: "URL sorgente",
            category: "Categoria",
            region: "Regione",
            endpoint_url: "URL endpoint",
            select_option: "Seleziona opzione",

            unsaved_title: "Hai modifiche non salvate",
            continue_unsaved: "Continua senza salvare",

            warning_points: [
                "Questa abilità diventerà permanentemente non disponibile per tutti gli utenti.",
                "Tutte le versioni di questa abilità verranno eliminate definitivamente.",
                "Tutti gli utenti perderanno definitivamente qualsiasi connessione a questa abilità.",
                "Ti verrà addebitato solo il tempo in cui l’istanza dell’abilità è stata attiva.",
                "Tutti i dati associati (chat, codice, URL, connessioni ecc.) verranno eliminati definitivamente."
            ],

            delete_ability: "Elimina abilità",
            delete_success_title: "Abilità eliminata con successo",
            delete_success_subtitle: "La tua abilità è stata rimossa. Verrai reindirizzato alla directory delle abilità...",

            delete_warning: "L’eliminazione di questa abilità è <strong>permanente</strong> e <strong>irreversibile</strong>. Una volta eliminata, sarà <strong>completamente rimossa dal sistema</strong>, incluse tutte le versioni, i dati associati (chat, codice, URL, ecc.) e qualsiasi connessione utente.<br /><br /><strong>QUESTA AZIONE NON PUÒ ESSERE ANNULLATA</strong>",

            all_warnings_checked: "Tutti gli avvisi devono essere selezionati",

            abilities_builder: "Builder di abilità",
            publishing: "Pubblicazione",
            publish: "Pubblica",
            versioning: "Versionamento",
            saving: "SALVATAGGIO",
            saving_sm: "Salvataggio",
            published: "PUBBLICATO",
            few_minutes: "Potrebbe richiedere alcuni minuti...",

            welcome_title: "Benvenuto nel builder di abilità",
            welcome_subtitle: "Crea, personalizza e distribuisci le tue abilità con facilità. Usa l’AI per generare e testare automaticamente la tua abilità oppure costruisci tutto manualmente con il tuo codice per il massimo controllo.",

            max_four_inst: "Puoi creare massimo 4 istanze.",
            publish_ability: "Pubblica abilità",

            public_warning: "Questa abilità verrà pubblicata globalmente per tutti gli utenti di Abstracht. Usala per la condivisione con la community. Assicurati che non contenga dati sensibili.",
            private_warning: "Questa abilità è privata e accessibile solo dal tuo account. Usala per test o scopi interni. Puoi pubblicarla successivamente nell’organizzazione.",

            compute_settings: "Impostazioni di calcolo",
            memory: "Memoria",
            scaling: "Scalabilità (istanze massime)",
            region: "Regione",
            region_warning: "Una volta impostata la regione durante la configurazione iniziale, non potrà essere modificata",
            network_warning: "L’accesso alla rete è impostato su Pubblico<br />Questa abilità è accessibile a chiunque abbia URL ed endpoint. Usa cautela nella condivisione.",
            publishing_warn: "Se questa non è la versione che ti aspettavi, salva le modifiche o seleziona un’altra versione prima di pubblicare.",
            settings: "Impostazioni",

            fill_field: "Compila il campo obbligatorio",
            auth_req: "L’autorizzazione è obbligatoria",
            failed_conn: "Connessione all’abilità fallita. Riprova.",
            creator: "Creatore",
            sys_provider: "Provider di sistema",
            config_req: "Configurazione richiesta",
            authorization: "Autorizzazione",
            i_auth: "Autorizzo Abstracht a eseguire questa abilità per mio conto.",

            disconnect_mex: "Se disconnetti, perderai l’accesso a tutte le funzionalità e i dati salvati verranno cancellati.",

            ability_logs: "Log dell’abilità",

            deployment_error: "Errore di deploy",
            deployment_err_subtitle: "Si è verificato un errore durante la pubblicazione dell’abilità. Controlla i log per i dettagli e riprova.",

            ability_info: "Info abilità",
            drafted_version: "Versione bozza",
            published_version: "Versione pubblicata",

            items_mcp: [
                {
                    desc: "Aiutami a mantenere aggiornati i contatti dei clienti analizzando le loro email recenti e applicando automaticamente le modifiche rilevanti."
                },
                {
                    desc: "Notifica il mio team su Slack ogni volta che appare una nuova opportunità di vendita nel CRM, così non perdiamo nulla di importante."
                },
                {
                    desc: "Organizza le mie note delle riunioni e assicurati che siano collegate automaticamente al progetto corretto in Notion."
                },
                {
                    desc: "Pianifica e programma le mie riunioni comprendendo priorità, disponibilità e suggerimenti di orario dall’assistente AI."
                },
                {
                    desc: "Monitora le attività di pagamento e avvisami quando avvengono eventi importanti come upgrade, cancellazioni o pagamenti falliti."
                },
                {
                    desc: "Analizza i nuovi lead e fornisci un riepilogo del loro valore potenziale con azioni di follow-up consigliate."
                },
                {
                    desc: "Ordina e prioritizza le email identificando i messaggi importanti dei clienti e raggruppandoli per urgenza e rilevanza."
                }
            ],

            new_chat: "Nuova chat",
            ask_anything: "Chiedimi qualsiasi cosa...",
            runt_test: "Esegui test",
            autotest_warn: "Quando l’autotest è attivo, l’AI pubblicherà e testerà automaticamente il MCP. Usare con cautela.",

            finalizing_conn: "Finalizzazione connessione...",
            connection_success: "Connessione riuscita!",
            connection_error: "Connessione fallita...",

            conn_succ_subtitle: "La connessione è avvenuta con successo. <br />Verrai reindirizzato a breve, mantieni questa finestra aperta.",
            conn_error: "Non siamo riusciti a stabilire la connessione. <br />Torna indietro e riprova oppure contatta il supporto se il problema persiste.",

            test_warn: "Stiamo testando la connessione inviando automaticamente un messaggio alla tua casella di posta. <br />Mantieni questa finestra aperta."
        },
        directory: {
            tag_required: "Il tag è obbligatorio",
            verified: "l’abilità e la sua connessione sono state verificate da Abstracht.",
            not_verified: "Stiamo attualmente validando il gateway di connessione con il team dei provider. Anche se la connessione è attiva e sicura, è ancora in fase di verifica da parte del provider. Durante il processo di connessione nella schermata di consenso, potresti vedere lo stato “non verificato” o “non verificata”: puoi ignorarlo e continuare la connessione.",
            once: "può essere aggiunta una sola volta per organizzazione.",
            multiple: "può essere aggiunta più volte per organizzazione.",
            no_permission: "Nessun permesso",
            warning_plublishing: "l’abilità verrà pubblicata all’interno delle organizzazioni selezionate e tutti i membri potranno connettersi ad essa.",
            addedd_success: "Abilità aggiunta con successo",
            confirmation: "L’abilità è stata aggiunta con successo al tuo account ed è ora pronta all’uso. Puoi accedervi in qualsiasi momento dalla sezione “Abilità”, dove apparirà insieme alle altre integrazioni attive.",
            continue_dir: "Continua nella directory",
            go_to: "Vai alla Console E8",
            get_ability: "Ottieni abilità",
            welcome: "Benvenuto nella directory delle abilità",
            explore: "Esplora una collezione in crescita di abilità pubbliche, importale facilmente nel tuo ambiente oppure condividi le tue creazioni con il mondo.",
            punchline_desc: "Le abilità trasformano i modelli linguistici da sistemi passivi a partecipanti attivi nel mondo reale. Vanno oltre le integrazioni statiche o i protocolli predefiniti: non sono semplici connettori o MCP, ma estensioni vive dell’intelligenza, progettate per crescere ed evolversi nel tempo."
        },
        omnit0: {
            kicker: "Siamo orgogliosi di...",
            description: "Omni-t0 è il sistema di orchestrazione intelligente sviluppato da Type Zero Research. <br/> <br/> Instrada dinamicamente ogni richiesta verso il modello AI più adatto in base all’intento dell’utente, alla complessità del compito, ai requisiti di velocità e al contesto. Il sistema opera attraverso un pool distribuito di modelli linguistici avanzati e provider di inferenza, combinando modelli di terze parti leader del settore con modelli proprietari ottimizzati e fine-tuned internamente da Type Zero Research. <br/> <br/> Valutando costantemente prestazioni, specializzazione, latenza ed efficienza dei costi, Omni-t0 fornisce risposte ottimizzate per un’ampia varietà di casi d’uso, dal ragionamento e programmazione fino alla generazione creativa e all’interazione multilingua.<br/><br/> Progettato come un layer di intelligenza multi-modello, Omni-t0 elimina la complessità della selezione dei modelli, permettendo agli utenti di interagire tramite un’unica interfaccia mentre il sistema sceglie automaticamente la migliore infrastruttura AI per ogni richiesta."
        },
        apps: {
            title: "Applicazioni",
            subtitle: "Gestisci e crea app.",
            empty_subtitle: "Crea e lancia web app in modo semplice, tutto in un unico posto.",
            quest_title: "Come funzionano le app?",
            quest_answ: "Le app possono essere create e distribuite per uso interno o pubblico, con supporto all'integrazione di funzionalità, flussi di lavoro e abilità.",

            title_required: "Il titolo è obbligatorio",
            desc_required: "La descrizione è obbligatoria",

            new_title: "Crea nuova app"
        },
        geo: {
            title: "GEO",
            subtitle: "Ottimizzazione GEO",
            empty_subtitle: "Simula come i motori di IA scoprono, comprendono e consigliano il tuo brand.",
            quest_title: "Cos'è la GEO?",
            quest_answ: "L'ottimizzazione per i motori generativi (GEO) aiuta il tuo brand a diventare più visibile e rilevante nelle risposte generate dall'IA. Analizza come i motori di IA comprendono la tua azienda, individua le lacune nella tua visibilità e simula strategie per migliorare il modo in cui il tuo brand viene scoperto, citato e consigliato.",
            title_required: "Inserisci un titolo",
            desc_required: "Inserisci una descrizione",
            new_title: "Nuova ottimizzazione GEO",
            update_title: "Aggiorna ottimizzazione GEO",
            name_required: "Il titolo dell'ottimizzazione GEO è obbligatorio...",
            desc_required: "La descrizione dell'ottimizzazione GEO è obbligatoria...",
            title_placeholder: "Es.: Lancio di un prodotto",
            description_placeholder: "Es.: Campagna di ottimizzazione per il lancio di un nuovo prodotto...",
            delete_title: "Elimina ottimizzazione GEO",
            delete_desc: "Questa operazione eliminerà definitivamente l'ottimizzazione e tutte le informazioni associate, interrompendo qualsiasi monitoraggio o esecuzione attiva. Una volta eliminata, l'operazione non potrà essere annullata.",
            geo_context_title: "Seleziona il tuo contesto",
            geo_context_description: "Scegli il contesto che guiderà le tue simulazioni AI e ne determinerà i risultati.",
            geo__prop_filter_placeholder: "Filtra per ID, nome, dominio, URL o data...",
            geo_filter_placeholder: "Filtra per ID, titolo, descrizione o data...",
            select_all: "Seleziona tutto",
            deselect_all: "Deseleziona tutto",
            item: "Elemento",
            items: "Elementi",
            no_sources: "Nessuna fonte",
            sources: "Fonti",
            source: "Fonte",
            warning_no_sources: "Alcuni dei contesti selezionati non hanno fonti! <br/> Per continuare, aggiungi almeno una fonte a ciascun contesto selezionato. In questo modo, le simulazioni AI potranno basarsi su informazioni pertinenti e fornire risultati più accurati.",
            need_context: "Hai bisogno di un nuovo contesto?",
            need_property: "Hai bisogno di una nuova proprietà?",
            click_here: "Clicca qui",
            define_goal_title: "Definisci il tuo obiettivo",
            define_goal_description: "Cosa vuoi ottenere con questa ottimizzazione GEO? Descrivi il tuo obiettivo per aiutare l'AI a individuare argomenti rilevanti per i potenziali clienti, generare simulazioni di ricerca realistiche e identificare opportunità per migliorare la tua visibilità sui diversi motori AI.",
            goal_placeholder: "Cosa vuoi ottenere con questa ottimizzazione?",
            goal_explain: "Il tuo obiettivo guida l'AI nella creazione di argomenti rilevanti per i clienti, simulazioni di ricerca realistiche e suggerimenti concreti in linea con i tuoi obiettivi.",
            topic_info: "Informazioni sull'argomento",
            new_topic: "Nuovo argomento",
            intent_type_required: "Il tipo di intento è obbligatorio...",
            intent_name_required: "Il nome dell'argomento è obbligatorio...",
            intent_desc_required: "La descrizione dell'argomento è obbligatoria...",
            intent_type: "Tipo di intento",
            topic: "Argomento",
            select_intent_type: "Seleziona il tipo di intento",
            topic_name_placeholder: "Inserisci un argomento...",
            topic_description_placeholder: "Descrivi l'argomento e le tipologie di intento dei clienti che dovrebbe coprire...",
            informational: "Informativo",
            commercial_investigation: "Valutazione commerciale",
            transactional: "Transazionale",
            comparative: "Comparativo",
            problem_solving: "Risoluzione dei problemi",
            context_id: "ID del contesto",
            topics: "Argomenti",
            geo_topics_description: "L'IA utilizzerà le tue selezioni per generare simulazioni pertinenti e realistiche.",
            create_custom_topic: "Crea un argomento personalizzato",
            geo_topics_warning: "Gli argomenti guidano l'IA nella generazione di domande e simulazioni realistiche, simili a quelle dei clienti, rispecchiando il modo in cui le persone cercano informazioni, pongono domande ed esplorano la tua attività.",
            preparing_discovery_title: "Preparazione all'analisi degli intenti",
            preparing_discovery_description: "Preparazione all'identificazione degli argomenti relativi agli intenti più pertinenti...",
            generating_topics_title: "Generazione degli argomenti relativi agli intenti",
            generating_topics_description: "Il tuo agente sta generando argomenti pertinenti in base al contesto e all'obiettivo...",
            failed_title: "Si è verificato un errore durante la generazione degli argomenti...",
            failed_description: "Verrai reindirizzato alla pagina precedente tra poco...",
            geo_engine_title: "Seleziona il motore AI",
            geo_engine_description: "Scegli dove eseguire le simulazioni. Seleziona uno o più motori, oppure tutti, per ottenere una visione più ampia della tua visibilità nei motori AI.",
            generate: "Genera",
            geo_prompt_warning: "simulazioni di prompt realistici basati sull'intento. <br /> Queste simulazioni riproducono le domande e i prompt che i potenziali clienti potrebbero utilizzare per cercare informazioni sulla tua attività.",

            prompt_rquired: "Il prompt è obbligatorio...",
            new_prompt: "Nuovo prompt",
            prompt: "Prompt",
            new_prompt_placeholder: "Inserisci il prompt in un linguaggio semplice e naturale.",

            prompt_info: "Informazioni sul prompt",
            reason_required: "La motivazione è obbligatoria...",
            classify_prompt: "Classifica il prompt",
            why_is_prompt: "Perché il prompt è",
            classify_placeholder: "Aggiungi una breve spiegazione del motivo per cui questo prompt viene classificato come",
            classify_warning: "Perché ti chiediamo di classificare il prompt? <br/>Classificando un prompt come positivo o negativo, ci aiuti a valutare la qualità e l'accuratezza delle risposte generate dall'IA. Il tuo feedback ci permette di individuare cosa funziona meglio, migliorare la qualità dei contenuti generati e perfezionare i nostri modelli per ottenere risultati più pertinenti e affidabi",
            POSITIVE: "positivo",
            NEGATIVE: "negativo",

            delete_prompt: "Elimina prompt",
            delete_prompt_desc: "Il prompt verrà eliminato definitivamente e non sarà più incluso nelle simulazioni. Questa azione non può essere annullata.",

            simulated_prompts: "Prompt simulati",
            simulated_prompts_desc: "Domande generate dall'IA che riflettono come le persone potrebbero cercare informazioni sui tuoi contenuti",
            add_custom_prompt: "Aggiungi un prompt personalizzato",
            gen_prompt_warning: "Questi prompt rappresentano le domande che i potenziali clienti potrebbero porre quando cercano informazioni sulla tua attività, riflettendo le loro esigenze, i loro interessi e le loro intenzioni di ricerca.",

            preparing_prompt_simulations: "Preparazione delle simulazioni dei prompt",
            preparing_prompt_simulations_desc: "Preparazione alla generazione delle simulazioni dei prompt...",

            running_prompt_simulations: "Creazione dei prompt simulati",
            running_prompt_simulations_desc: "Generazione di prompt per simulare interazioni realistiche con gli utenti",

            select_a_language: "Seleziona una lingua",
            select_a_language_desc: "Scegli la lingua per le tue simulazioni",
            select_language: "Seleziona lingua",
            select_language_warning: "Tutti gli argomenti generati, i prompt simulati e le simulazioni finali utilizzeranno la lingua selezionata per garantire coerenza e risultati più pertinenti.",

            add_property_geo: "Aggiungi il tuo sito web",
            add_property_geo_desc: "Inizia dal sito web che desideri ottimizzare.",
            add_property_geo_warning: "Il dominio fornito sarà la base per tutte le analisi, gli approfondimenti e le azioni di ottimizzazione durante questo processo.",
            add_property_geo_warning_validate: "Verifica dell'accessibilità del sito web e controllo che sia pronto per l'analisi.",

            failed_to_validate: "Impossibile convalidare l'URL...",
            url_non_reachable: "URL non raggiungibile...",
            unable_to_validate: "Impossibile verificare l'URL...",

            running_sim_title: "Simulazione dei prompt in corso",
            running_sim_desc: "Il nostro agente sta testando i tuoi prompt su diversi motori di IA per valutarne le risposte.",

            overview: "Panoramica",
            context: "Contesto",
            topics: "Argomenti",
            prompts: "Prompt",
            simulation_settings: "Impostazioni",
            actions: "Azioni",

            visibility: "Visibilità",
            effectiveness: "Efficacia",
            position: "Posizione",
            sentiment: "Sentiment",

            up: "IN AUMENTO",
            down: "IN DIMINUZIONE",

            is_trending: "è in",

            natural: "Naturale",
            linear: "Lineare",

            select_engines: "Seleziona i motori",
            select_prompt: "Seleziona un prompt",
            select_metric: "Seleziona una metrica",

            from: "Da",
            to: "A",

            line_style: "Stile della linea",

            select_valid_date: "Seleziona un intervallo di date valido...",
            no_data_available_for_params: "Nessun dato disponibile per i parametri selezionati...",

            engine: "Motore",
            engines: "Motori",
            simulations: "simulazioni",
            simulation: "simulazione",

            details: "Dettagli",
            engine_answer: "Risposta del motore IA",
            citations: "Citazioni",
            sources: "Fonti",
            strengths: "Punti di forza",
            weaknesses: "Punti di debolezza",
            improvements: "Suggerimenti per miglioramenti",

            schedule_settings_title: "Impostazioni di pianificazione",
            every: "Ogni",
            at: "Alle",
            schedule_warn: "Il monitoraggio GEO verrà eseguito automaticamente all'intervallo configurato. Le azioni verranno eseguite solo se abilitate.",
            run: "Esegui ogni",
            day: "Giorno",
            days: "Giorni",
            week: "Settimana",
            weeks: "Settimane",
            month: "Mese",
            months: "Mesi",
            interval_err: "Inserisci un intervallo compreso tra 1 e",
            time_err: "L'orario è obbligatorio...",

            monitoring_title: "Monitoraggio simulazioni",
            monitoring_summary: "Monitora i risultati delle simulazioni dei prompt GEO sui motori di intelligenza artificiale selezionati.",
            sim_monitoring_title: "Monitoraggio delle simulazioni GEO",

            select_action_title: "Seleziona un'azione",
            select_action_desc: "Seleziona un'azione per esplorarne i dettagli, esaminare le modifiche proposte e gestire il modo in cui Abstracht ottimizza il tuo sito web.",

            analysis: "Analisi",
            applied_strategy: "Strategia applicata",
            potential_outcome: "Risultato potenziale",
            optimizations: "Ottimizzazioni",
            analyzed_strategies: "Strategie analizzate",

            approach: "Approccio",
            evaluation_window_days: "Periodo di valutazione (giorni)",
            objective: "Obiettivo",
            success_metrics: "Metriche di successo",
            confidence: "Livello di affidabilità",
            high: "Alto",
            medium: "Medio",
            low: "Basso",
            description: "Descrizione",
            estimated_impact: "Impatto stimato",
            limitations: "Limitazioni",
            effort: "Impegno richiesto",
            expected_benefit: "Beneficio atteso",
            id: "ID",
            priority: "Priorità",
            problem: "Problema",
            reasoning: "Motivazione",
            recommendation: "Raccomandazione",
            type: "Tipo"
        },
        ads: {
            title: "Pubblicità",
            subtitle: "Ottimizzazione pubblicitaria basata sull'IA",
            empty_subtitle: "Crea, ottimizza e migliora continuamente le tue campagne pubblicitarie con l'IA.",
            quest_title: "Cosa sono le Pubblicità?",
            quest_answ: "La pubblicità basata sull'IA ti aiuta a creare, analizzare e ottimizzare campagne sulle piattaforme pubblicitarie. Genera segmenti di pubblico e parole chiave ad alta intenzione, valuta le opportunità delle campagne, ottimizza budget e creatività e migliora continuamente le prestazioni sulla base dei dati reali delle campagne.",

            title_required: "Inserisci un titolo",
            desc_required: "Inserisci una descrizione",

            new_title: "Nuova ottimizzazione pubblicitaria"
        },
        context: {
            title: "Contesto",
            subtitle: "Contesto e informazioni sull'IA",
            empty_subtitle: "Fornisci all'IA le informazioni e il contesto necessari per comprendere il tuo brand e creare simulazioni accurate.",
            quest_title: "Cos'è il contesto?",
            quest_answ: "Il contesto fornisce le informazioni che l'IA utilizza per comprendere la tua azienda, i tuoi prodotti, servizi, pubblico e posizionamento. Offre agli strumenti di IA le informazioni pertinenti necessarie per creare simulazioni più coerenti, accurate, pertinenti e realistiche.",
            title_required: "Inserisci un titolo",
            desc_required: "Inserisci una descrizione",
            new_title: "Nuovo contesto",
            name_required: "Il titolo del contesto è obbligatorio",
            desc_required: "La descrizione del contesto è obbligatoria",
            delete_title: "Elimina contesto",
            delete_desc: "L'eliminazione di questo contesto rimuoverà definitivamente le informazioni in esso contenute. Tutte le simulazioni, le campagne o le ottimizzazioni che lo utilizzano non potranno più accedere a queste informazioni. Questa azione è irreversibile.",

            delete_title_source: "Elimina fonte",
            delete_desc_source: "L'eliminazione di questa fonte rimuoverà definitivamente le informazioni in esso contenute. Tutte le simulazioni, le campagne o le ottimizzazioni che lo utilizzano non potranno più accedere a queste informazioni. Questa azione è irreversibile.",

            title_placeholder: "Es.: Informazioni sul prodotto",
            description_placeholder: "Es.: Pagina del prodotto e descrizione",
            description_placeholder_2: "Es.: Una descrizione dettagliata del prodotto...",
            open_context_title: "Crea un contesto completo",
            open_context_description: "Riunisci fonti, documenti e dati pertinenti per creare un contesto ricco e affidabile. Più le informazioni fornite saranno pertinenti, meglio il contesto riuscirà a rappresentare il quadro completo e a fornire risultati più accurati e significativi.",
            add_new_source_title: "Aggiungi una nuova fonte",
            add_new_source_description: "Collega diverse fonti per creare un contesto più ricco e completo.",
            context_logs_title: "Registri",
            loading_logs: "Caricamento dei registri...",
            logs_timestamp: "Data e ora",
            logs_message: "Messaggio",
            source_urls: "Fonti",
            created_at: "Creato il",
            last_synced_at: "Ultima sincronizzazione",
            status: "Stato",
            source_type: "Tipo di fonte",
            id: "ID",
            QUEUED: "IN CODA",
            RUNNING: "IN ESECUZIONE",
            FAILED: "NON RIUSCITO",
            COMPLETED: "COMPLETATO",
            view_logs_btn: "Visualizza registri",
            source_overview: "Panoramica della fonte",
            total_pages: "Pagine totali",
            summarized_pages: "Pagine riassunte",
            total_chunks: "Segmenti totali",
            last_updated: "Ultimo aggiornamento",
            indexed_at: "Indicizzato il",
            chunks: "Segmenti",
            custom_source: "Fonte personalizzata",
            read: "Leggi",
            one_page_summary: "Riepilogo di una pagina",
            page_summaries: "Riepiloghi delle pagine",
            no_summary_available: "Nessun riepilogo disponibile per questa pagina",
            initializing: "Inizializzazione...",
            processing: "Elaborazione...",
            extracting: "Estrazione...",
            indexing: "Indicizzazione...",
            building: "Creazione della fonte...",
            almost_done: "Quasi completato...",
            update_context_title: "Aggiorna il contesto",
            title_required: "Il titolo è obbligatorio",
            text_required: "Il testo è obbligatorio",
            text: "Testo",
            set_custom_context: "Imposta contesto personalizzato",
            loading_content: "Caricamento dei contenuti...",
            please_select_url: "Seleziona almeno un URL.",
            add_url_title: "Aggiungi l'URL di un sito web",
            add_utl_description: "Inserisci l'URL del tuo sito web per consentire al sistema di analizzare il sito ed estrarre le informazioni pertinenti. Puoi scegliere di eseguire la scansione dell'intero sito web oppure selezionare pagine specifiche.",
            urls_appear_title: "Gli URL appariranno qui...",
            url_warning: "Alcuni siti web potrebbero limitare l'accesso, impedendo l'estrazione o l'analisi dei loro contenuti.",
            start_web_extraction: "Avvia l'estrazione dal web",
            select_all: "Seleziona tutto",
            deselect_all: "Deseleziona tutto",
            please_select_file: "Seleziona almeno un file.",
            failed_upload: "Caricamento dei file non riuscito...",
            add_docs_title: "Aggiungi documenti e file",
            add_docs_description: "Carica i tuoi documenti e file per consentire al sistema di estrarre ed elaborare le informazioni pertinenti. Puoi selezionare più file da includere nella tua base di conoscenza.",
            select_files: "Seleziona file",
            selected_files_appear: "I file selezionati appariranno qui...",
            remove_all: "Rimuovi tutto",
            selected: "selezionati",
            remove: "Rimuovi",
            upload_documents: "Carica documenti",
            new_source: "Nuova fonte",
            source_not_available: "non è ancora disponibile.",
            website: "Sito web",
            documents: "Documenti",
            custom: "Personalizzato"
        },
        properties: {
            title: "Proprietà",
            subtitle: "Gestisci le tue proprietà e fai crescere i tuoi agenti di crescita",
            empty_subtitle: "Collega le tue proprietà per sbloccare la crescita basata sull'intelligenza artificiale",
            quest_title: "Cosa sono le proprietà?",
            quest_answ: "Le proprietà sono i siti web che gli agenti di Abstracht monitorano e ottimizzano attraverso tutti i moduli. Collega una proprietà per monitorare le prestazioni, individuare opportunità e trasformare le strategie di crescita in azioni concrete.",

            tag_not_installed: "Tag non installato",

            name_required: "Il nome della proprietà è obbligatorio...",
            base_url_required: "L'URL di base è obbligatorio...",
            domain_required: "Il dominio è obbligatorio...",

            new_title: "Nuova proprietà",
            base_url: "URL di base",
            domain: "Dominio",
            verify_domain_warn: " Verifica che il dominio sia corretto e punti al sito web che desideri monitorare e ottimizzare.",

            deployment: "Distribuzione",
            enabled: "Abilitato",
            disabled: "Disabilitato",
            deployment_warn: "La distribuzione è abilitata. Gli agenti di Abstracht possono apportare modifiche direttamente al tuo sito web.",

            update_title: "Aggiorna proprietà",

            delete_title: "Elimina proprietà",
            delete_desc: "Questa operazione eliminerà definitivamente la proprietà e tutte le informazioni associate, interrompendo ogni attività di monitoraggio o esecuzione in corso. Una volta eliminata, l'operazione non potrà essere annullata.",

            install_tag_title: "Installa il tag di Abstracht",
            install_on: "Installa il tag su",
            to_enable: "per abilitare il monitoraggio e le ottimizzazioni automatizzate.",
            not_installed: "Il tag non è installato",
            tag_warn_one: "Il tag consente agli agenti AI di Abstracht di monitorare le prestazioni del sito web e applicare ottimizzazioni direttamente sul tuo sito, in base alle autorizzazioni e alle impostazioni configurate.",
            tag_warn_two: "Hai bisogno di aiuto con l'installazione? Consulta la guida",

            how_to_title: "Come installare il tag?",
            how_to_desc:
                "Segui le istruzioni riportate di seguito per installare il tag di Abstracht sul tuo sito web. Scegli la procedura più adatta alla tecnologia utilizzata dal tuo sito.",

            how_to_step_copy_title: "1. Copia il tag di installazione",
            how_to_step_copy_desc:
                "Copia il codice qui sotto. Contiene l'identificativo di questa proprietà, quindi assicurati di utilizzare il tag corretto per il tuo sito web.",

            how_to_step_type_title: "2. Scegli il tipo di sito web",
            how_to_tab_standard: "Sito web tradizionale",
            how_to_tab_spa: "Applicazione a pagina singola (SPA)",
            how_to_tab_tagmanager: "Gestore di tag",

            how_to_standard_subtitle: "Per i siti web tradizionali",
            how_to_standard_step_1:
                "Apri il modello HTML del tuo sito web o il file di layout condiviso.",
            how_to_standard_step_2:
                "Individua il tag di chiusura",
            how_to_standard_step_3:
                "Incolla il tag di installazione subito prima di",
            how_to_standard_step_4:
                "Salva le modifiche e pubblica il sito web.",
            how_to_standard_desc:
                "Aggiungi il tag a un layout condiviso o a un modello globale, in modo che venga incluso in tutte le pagine in cui desideri utilizzare Abstracht. In genere, non è necessario aggiungerlo singolarmente a ogni pagina.",

            how_to_spa_subtitle:
                "Per React, Vue, Angular e altre SPA",
            how_to_spa_desc:
                "Un'applicazione a pagina singola (SPA) può passare da una pagina all'altra senza ricaricare l'intero sito web. Aggiungi il tag al documento HTML principale, così verrà caricato insieme alla tua applicazione.",
            how_to_spa_step_1:
                "Apri il file HTML principale della tua applicazione. In React, spesso si trova in public/index.html oppure in index.html, a seconda della configurazione del progetto.",
            how_to_spa_step_2:
                "Incolla il tag di installazione all'interno della sezione",
            how_to_spa_step_3:
                "Salva le modifiche e ricostruisci o distribuisci l'applicazione secondo le esigenze del framework utilizzato.",
            how_to_spa_step_4:
                "Pubblica le modifiche sul tuo sito web online.",
            how_to_spa_desc_2:
                "Aggiungi il tag al documento HTML principale una sola volta. Se utilizzi il routing lato client, eventuali configurazioni aggiuntive per gestire la navigazione tra le diverse route dipendono dall'integrazione di tracciamento della tua applicazione.",

            how_to_tagmanager_subtitle:
                "Per i siti web che utilizzano un gestore di tag",
            how_to_tagmanager_step_1:
                "Apri il tuo gestore di tag, ad esempio Google Tag Manager.",
            how_to_tagmanager_step_2:
                "Crea un nuovo tag utilizzando l'opzione HTML personalizzato, se disponibile.",
            how_to_tagmanager_step_3:
                "Incolla il tag di installazione di Abstracht nella configurazione del tag.",
            how_to_tagmanager_step_4:
                "Configura il trigger in modo che il tag venga eseguito sulle pagine in cui desideri installarlo.",
            how_to_tagmanager_step_5:
                "Salva e pubblica il contenitore del gestore di tag.",
            how_to_tagmanager_desc:
                "Assicurati che le modifiche al gestore di tag siano state pubblicate e non siano rimaste soltanto salvate come bozza.",

            how_to_step_publish_title: "3. Pubblica le modifiche",
            how_to_step_publish_desc:
                "Salva le modifiche e pubblica il tuo sito web. Assicurati che il tag di installazione sia presente nelle pagine in cui desideri utilizzare Abstracht.",

            how_to_support:
                "Se hai bisogno di aiuto per installare il tag o riscontri problemi, contattaci all'indirizzo",

            connection_title: "Connessione",

            connected_status: "Connesso",
            connected_status_desc: "Il tag è stato rilevato sul tuo sito web",

            not_installed_status: "Non installato",
            not_installed_status_desc: "Installa il tag di Abstracht per abilitare la connessione al sito web",
            not_installed_status_desc_geo: "Installa il tag di Abstracht per collegare il sito web. <br/> Nel frattempo, potrai comunque monitorarne le performance.",
            connection_error_status: "Errore di connessione",
            connection_error_status_desc: "Si è verificato un problema con il tag. Controlla l'installazione",

            verification_title: "Verifica",

            verified_status: "Verificato",
            verified_status_desc: "La proprietà del sito web è stata confermata il",

            verification_failed_status: "Verifica non riuscita",
            verification_failed_status_desc: "Non è stato possibile verificare la proprietà del sito web. Controlla le impostazioni di verifica.",

            pending_verification_status: "Verifica in sospeso",
            pending_verification_status_desc: "Completa la verifica per confermare la proprietà del sito web",

            deployment_title: "Distribuzione",

            deployment_enabled_status: "Abilitata",
            deployment_enabled_status_desc: "Gli agenti possono applicare modifiche al tuo sito web.",

            deployment_disabled_status: "Disabilitata",
            deployment_disabled_status_desc: "Abilita la distribuzione per consentire agli agenti di Abstracht di applicare modifiche direttamente al tuo sito web.",

            last_activity_title: "Ultima attività del tag",
            last_activity_date_desc: "Data dell'ultima attività",
            last_activity_time_desc: "Ora dell'ultima attività",

            verify_domain_desc: "Conferma la proprietà del sito web per completare la verifica.",
            verify_domain_btn: "Verifica",

            enable_deployment_desc: "Consenti agli agenti di Abstracht di applicare modifiche direttamente al tuo sito web.",
            enable_deployment_btn: "Abilita",

            verify_domain_title: "Verifica della proprietà del dominio",
            type: "Tipo",
            data: "Dati",
            verify_domain_own_warn: "La verifica del dominio conferma che possiedi o controlli il sito web, consentendo ad Abstracht di gestire la tua proprietà in modo sicuro. Le modifiche ai record DNS potrebbero richiedere alcuni minuti per propagarsi.",
            provider_message: "Messaggio del provider",
        }


    }
}